<template>
        <vue-page-transition name="fade-in-down">
        <v-content class="bg-content prompt-runner-working">
          <section v-if="artistData" class="artist-header">
  <div class="artist-head">
    <img
      v-if="artistData?.images?.length"
      :src="artistData.images[0].url"
      alt="Artist Image"
      class="artist-avatar2"
    />
    <div class="artist-meta">
      <h3 class="artist-name">{{ artistData.name }}</h3>
      <div class="chips">
        <span class="chip">Popularity: {{ artistData.popularity }}</span>
        <span class="chip">Followers: {{ artistData.followers?.total?.toLocaleString?.() || 0 }}</span>
        <span v-for="(g,i) in (artistData.genres || []).slice(0,3)" :key="i" class="chip">{{ g }}</span>
      </div>
      <a
        v-if="artistData?.external_urls?.spotify"
        :href="artistData.external_urls.spotify"
        target="_blank"
        class="link"
      >Open on Spotify ↗</a>
    </div>
  </div>
</section>
  <div class="dashboard">
    <div  class="card glass input-card">
      
      <h3>AI Artist Analysis</h3>
<!-- STATUS AVATAR -->
<div class="avatar-wrap" :class="avatarState">
  <div class="avatar">
    <img
      :src="aiAnalystIcon"
      alt="AI Analyst"
      class="avatar-icon"
      :class="avatarState"
    />
  </div>

  <div class="avatar-note">
    <span v-if="avatarState==='searching'">Searching…</span>
    <span v-else-if="avatarState==='analyzing'">Analyzing tours…</span>
    <span v-else-if="avatarState==='done'">Report ready</span>
    <span v-else-if="avatarState==='error'">{{ error }}</span>
    <span v-else>&nbsp;</span>
  </div>
</div>


      <form @submit.prevent="runResearch" class="form">
        <input
  v-model.trim="artistName"
  type="text"
          placeholder="Ask anything: “Beyoncé tour & predictions & contacts”, “Research Drake past tours and predict future tours”, “Taylor Swift management team contacts”…"
          class="input"
          required
        />
        <button class="btn" :disabled="loading || !artistName">
          {{ loading ? 'Analyzing…' : 'Run Research' }}
        </button>
      </form>

      <transition name="fade">
        <div v-if="error" class="error">⚠️ {{ error }}</div>
      </transition>
    </div>
  <!-- ANALYZE + PREDICT CONTROLS -->
<!-- <div class="toolbar" style="margin-top:.75rem; gap:.5rem; position:relative; z-index:10;">
  <button type="button" class="btn small" @click.stop="collectPastTours([], { silent: false })" :disabled="loading">
    📥 Collect Past Tours
  </button>
  <button type="button" class="btn small" @click.stop="analyzeTours(3)" :disabled="!pastTours.length">
    📈 Analyze Tours
  </button>
  <button type="button" class="btn small" @click.stop="predictFutureTours()" :disabled="!pastTours.length || predicting">
    🔮 Predict Future Tours
  </button>
</div> -->

<button @click="requestFinalAgentBrief" class="btn btn-primary">
  Run Final Agent Brief    
</button>

 

<!-- 🆕 Final Agent Brief panel -->
<section
  v-if="agentTalkTrack"
  class="agent-brief-card mt-4 p-4 rounded-xl border border-blue-500/40 bg-slate-900/70"
>
  <header class="flex items-center justify-between mb-2">
    <div class="text-sm font-semibold tracking-wide text-sky-300 uppercase">
      Final Agent Brief
    </div>
    <div class="flex items-center gap-2">
      <button
        v-if="!isReadingTalk"
        @click="readAgentTalkTrack"
        class="px-3 py-1 rounded-full text-xs font-semibold bg-sky-500/80 hover:bg-sky-400 text-white"
      >
        🔊 Play Brief
      </button>
<button
    v-if="!isReadingTalk"
    @click="readAgentTalkTrack(true)"
    class="px-3 py-1 rounded-full text-xs font-semibold bg-sky-500/80 hover:bg-sky-400 text-white"
  >
    🔊 Start Over
  </button>

  <!-- When reading: Stop + Start Over controls -->
  <template v-else>
    <button
      @click="stopAgentTalkTrack"
    class="px-3 py-1 rounded-full text-xs font-semibold bg-sky-500/80 hover:bg-sky-400 text-white"
    >
      ⏹ Stop
    </button>
    <button
      @click="readAgentTalkTrack(true)"
    class="px-3 py-1 rounded-full text-xs font-semibold bg-sky-500/80 hover:bg-sky-400 text-white"
    >
      🔁 Start Over
    </button>
  </template>
    </div>
  </header>

  <div class="text-xs text-slate-200/90 leading-relaxed max-h-60 overflow-auto whitespace-pre-wrap agent-brief-text">
    {{ agentTalkTrack }}
  </div>
</section>

    <!-- APPROVAL PANEL -->
    <section v-if="confirmVisible && pendingAction" class="block confirm-panel">
      <div class="toolbar">
        <h4>✅ Ready to execute the model’s proposed action?</h4>
        <span class="muted">Review & approve before sending to the agent.</span>
      </div>

      <div class="confirm-body">
        <div class="confirm-row">
          <strong>Intent:</strong>
          <code class="code-chip">{{ pendingAction.intent || 'unknown_intent' }}</code>
        </div>

        <div class="confirm-row" v-if="pendingAction.description">
          <strong>Description:</strong>
          <span>{{ pendingAction.description }}</span>
        </div>

        <div class="confirm-row">
          <strong>Arguments:</strong>
          <pre class="json-output">{{ pretty(pendingAction.args || {}) }}</pre>
        </div>

        <div class="export-controls">
          <button class="btn" @click="approveAction" :disabled="sendingAgent">
            {{ sendingAgent ? 'Sending…' : 'Approve & Send to Agent' }}
          </button>
          <button class="btn ghost" @click="rejectAction" :disabled="sendingAgent">Cancel</button>
        </div>

        <transition name="fade">
          <div v-if="agentError" class="error">⚠️ {{ agentError }}</div>
        </transition>
      </div>
    </section>
    <!-- Artist header card: shows instantly after Spotify lookup -->


    <transition name="fade">
      <div v-if="hasAnyReport" class="card glass result">
        <div class="toolbar">
          <h3><strong>{{ titleText }}</strong></h3>
          <div class="view-switch">
            <button class="btn small" :class="{ ghost: outputMode !== 'text' }"     @click="outputMode = 'text'">Report</button>
            <button class="btn small" :class="{ ghost: outputMode !== 'contacts' }" @click="outputMode = 'contacts'" :disabled="!hasContacts">Contacts</button>
            <button class="btn small" :class="{ ghost: outputMode !== 'tours' }"    @click="outputMode = 'tours'" :disabled="!hasAnyTours">Tours</button>
            <button class="btn small" :class="{ ghost: outputMode !== 'json' }"     @click="outputMode = 'json'" :disabled="!jsonAvailable">JSON</button>
          </div>
        </div>

        <!-- TEXT -->
        <!-- <section v-if="outputMode === 'text'" class="text-report">
          <pre class="mono">{{ textReport || 'No text was returned by the model.' }}</pre>
        </section>
        <div v-if="!reportObj && textReport && textReport.startsWith('{')" class="error">
          ⚠️ The report looks like raw JSON but failed to parse into a structured object.
        </div> -->
        <!-- DASHBOARD CARDS -->
                 <section v-if="outputMode === 'contacts'">
          <h4>👥 Contacts</h4>
          <div v-if="hasContacts">
            <div class="scroll-x">
              <table class="table">
                <thead>
                  <tr>
                    <th>Role</th><th>Name</th><th>Email</th><th>Phone</th><th>Website</th><th>Social</th><th>LinkedIn</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(c, i) in reportObj.contacts" :key="'c'+i">
                    <td>{{ c.role || '—' }}</td>
                    <td>{{ c.name || '—' }}</td>
                    <td><a v-if="c.email" :href="'mailto:'+c.email">{{ c.email }}</a><span v-else>—</span></td>
                    <td><a v-if="c.phone" :href="'tel:'+c.phone">{{ c.phone }}</a><span v-else>—</span></td>
                    <td><a v-if="c.website" :href="c.website" target="_blank">{{ c.website }}</a><span v-else>—</span></td>
                    <td>
                      <div class="stack">
                        <a v-for="(s, si) in (c.socials || [])" :key="'s'+si" :href="s" target="_blank">{{ s }}</a>
                        <span v-if="!c.socials || !c.socials.length">—</span>
                      </div>
                    </td>
                    <td><a v-if="c.linkedin" :href="c.linkedin" target="_blank">LinkedIn</a><span v-else>—</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-else class="muted">No contacts found in this report.</div>
        </section>
                <section v-if="outputMode === 'tours'">
          <h4>🎟️ Tours</h4>
          <div class="tour-columns">
            <div>
              <h4>Past Tours</h4>
              <ul class="list">
                <li v-for="(t, i) in (reportObj.pastTours || [])" :key="'pt'+i">
                  <strong>{{ t.city || 'City' }}</strong>
                  <span v-if="t.venue"> — {{ t.venue }}</span>
                  <span v-if="t.date"> • {{ t.date }}</span>
                  <span v-if="t.capacity"> • cap {{ t.capacity }}</span>
                </li>
              </ul>
              <div v-if="!reportObj.pastTours || !reportObj.pastTours.length" class="muted">No past tour items.</div>
            </div>

            <div>
              <h4>Predicted / Future Tours</h4>
              <ul class="list">
                <li v-for="(t, i) in (reportObj.futureTours || [])" :key="'ft'+i">
                  <strong>{{ t.city || 'City' }}</strong>
                  <span v-if="t.venue"> — {{ t.venue }}</span>
                  <span v-if="t.window"> • {{ t.window }}</span>
                  <span v-if="t.confidence != null"> • conf {{ t.confidence }}</span>
                  <span v-if="t.capacity"> • cap {{ t.capacity }}</span>
                </li>
              </ul>
              <div v-if="!reportObj.futureTours || !reportObj.futureTours.length" class="muted">No predicted tour items.</div>
            </div>
          </div>
        </section>
<section class="cards-grid" v-if="reportObj">
  <!-- Artist -->
   <!-- Recommendations & Next Steps -->
<article class="card full">
  <div class="row">
    <h3>Recommendations & Next Steps</h3>
    <div class="spacer"></div>
    <button class="btn small ghost" @click="copyRecos">📋 Copy</button>
  </div>

  <div class="grid-two">
    <div>
      <h6 class="muted">Recommendations</h6>
      <ul class="checklist">
        <li v-for="(r,i) in recoList" :key="'reco'+i">{{ r }}</li>
        <li v-if="!recoList.length" class="muted">No recommendations yet.</li>
      </ul>
    </div>

    <div>
      <h6 class="muted">Next Steps</h6>
      <ul class="checklist">
        <li v-for="(s,i) in nextStepsList" :key="'step'+i">{{ s }}</li>
        <li v-if="!nextStepsList.length" class="muted">No next steps yet.</li>
      </ul>
    </div>
  </div>
</article>

  <article class="card full glass">
    <section v-if="artistData" class="card glass artist-header">
  <div class="artist-head">
    <img
      v-if="artistData?.images?.length"
      :src="artistData.images[0].url"
      alt="Artist Image"
      class="artist-avatar"
    />
    <div class="artist-meta">
      <h3 class="artist-name">{{ artistData.name }}</h3>
      <div class="chips">
        <span class="chip">Popularity: {{ artistData.popularity }}</span>
        <span class="chip">Followers: {{ artistData.followers?.total?.toLocaleString?.() || 0 }}</span>
        <span v-for="(g,i) in (artistData.genres || []).slice(0,3)" :key="i" class="chip">{{ g }}</span>
      </div>
      <a
        v-if="artistData?.external_urls?.spotify"
        :href="artistData.external_urls.spotify"
        target="_blank"
        class="link"
      >Open on Spotify ↗</a>
    </div>
  </div>
</section>
    <h4>Artist</h4>
    <div class="kvs">
      <div><span class="k">Name</span><span class="v">{{ titleText }}</span></div>
      <div v-if="(reportObj.profile?.aka||[]).length">
        <span class="k">AKA</span><span class="v">{{ reportObj.profile.aka.join(', ') }}</span>
      </div>
      <div v-if="reportObj.profile?.hometown"><span class="k">Hometown</span><span class="v">{{ reportObj.profile.hometown }}</span></div>
      <div v-if="reportObj.profile?.yearsActive"><span class="k">Years Active</span><span class="v">{{ reportObj.profile.yearsActive }}</span></div>
      <div v-if="(reportObj.profile?.labels||[]).length"><span class="k">Label(s)</span><span class="v">{{ reportObj.profile.labels.join(', ') }}</span></div>
    </div>
        <h4>Music Style</h4>
    <div class="chips" v-if="(reportObj.profile?.genres||[]).length">
      <span class="chip" v-for="(g,i) in reportObj.profile.genres" :key="'g'+i">{{ g }}</span>
    </div>
    <p class="muted" v-else>No genres listed.</p>
  </article>

  <!-- History -->
  <!-- <article class="card mini glass">
    <h4>History</h4>
    <p class="muted" v-if="!reportObj.profile?.description">No bio/description provided.</p>
    <p v-else>{{ reportObj.profile.description }}</p>
  </article> -->

  <!-- Music Style -->
  <!-- <article class="card mini glass">
    <h4>Music Style</h4>
    <div class="chips" v-if="(reportObj.profile?.genres||[]).length">
      <span class="chip" v-for="(g,i) in reportObj.profile.genres" :key="'g'+i">{{ g }}</span>
    </div>
    <p class="muted" v-else>No genres listed.</p>
  </article> -->

  <!-- Audience -->
  <article class="card wide glass">
        <h4>History</h4>
    <p class="muted" v-if="!reportObj.profile?.description">No bio/description provided.</p>
    <p v-else>{{ reportObj.profile.description }}</p>
    <br />
    <h4>Audience</h4>
    <div class="kvs">
      <div v-if="(reportObj.audience?.topMarkets||[]).length">
        <span class="k">Top Markets</span>
        <span class="v">{{ reportObj.audience.topMarkets.slice(0,8).join(', ') }}</span>
      </div>
      <div v-if="reportObj.audience?.demographics?.coreAge">
        <span class="k">Core Age</span><span class="v">{{ reportObj.audience.demographics.coreAge }}</span>
      </div>
      <div v-if="reportObj.audience?.demographics?.genderSkew">
        <span class="k">Gender</span><span class="v">{{ reportObj.audience.demographics.genderSkew }}</span>
      </div>
    </div>
        <br />
        <h4>Touring Patterns</h4>
    <div class="kvs">
      <div><span class="k">Window</span><span class="v">{{ tourStats.windowYears }} yrs (since {{ tourStats.since }})</span></div>
      <div><span class="k">Dated Shows</span><span class="v">{{ tourStats.count }}</span></div>
      <div v-if="tourStats.gapsDays?.median!=null"><span class="k">Median Gap</span><span class="v">{{ tourStats.gapsDays.median }} days</span></div>
      <div v-if="tourStats.capacity?.avg!=null"><span class="k">Avg Capacity</span><span class="v">{{ tourStats.capacity.avg }}</span></div>
    </div>
  </article>

  <!-- Touring Patterns (auto from analyzeTours) -->
  <!-- <article class="card wide" v-if="tourStats">
    <h4>Touring Patterns</h4>
    <div class="kvs">
      <div><span class="k">Window</span><span class="v">{{ tourStats.windowYears }} yrs (since {{ tourStats.since }})</span></div>
      <div><span class="k">Dated Shows</span><span class="v">{{ tourStats.count }}</span></div>
      <div v-if="tourStats.gapsDays?.median!=null"><span class="k">Median Gap</span><span class="v">{{ tourStats.gapsDays.median }} days</span></div>
      <div v-if="tourStats.capacity?.avg!=null"><span class="k">Avg Capacity</span><span class="v">{{ tourStats.capacity.avg }}</span></div>
    </div>
  </article> -->

  <!-- Past Tours + per-year chart -->
  <article class="card wide">
    <div class="row">
      <h4>Past Tours</h4>
      <div class="spacer"></div>
      <button class="btn small ghost" @click="fetchMorePastTours" :disabled="loading">🔎 Load More</button>
    </div>

    <ul class="list compact" v-if="(reportObj.pastTours||[]).length">
      <li v-for="(t,i) in reportObj.pastTours.slice(0,30)" :key="'ptc'+i">
        <strong>{{ t.city || 'City' }}</strong>
        <span v-if="t.venue"> — {{ t.venue }}</span>
        <span v-if="t.date"> • {{ t.date }}</span>
        <span v-if="t.capacity"> • cap {{ t.capacity }}</span>
      </li>
      <li v-if="reportObj.pastTours.length>30" class="muted">+ {{ reportObj.pastTours.length-30 }} more…</li>
    </ul>
    <p v-else class="muted">No past tour items.</p>

    <div class="chart-wrap sm">
      <canvas id="pastYearChart"></canvas>
    </div>
  </article>

  <!-- Extra charts -->
  <article class="card wide">
    <h4>Capacity Histogram</h4>
    <div class="chart-wrap sm"><canvas id="capacityHistChart"></canvas></div>
  </article>

  <article class="card full glass">
    <h4>Top Regions (Past)</h4>
    <div class="chart-wrap sm"><canvas id="pastRegionChart"></canvas></div>
  </article>
</section>

        <!-- CONTACTS -->
        <section v-if="outputMode === 'contacts'">
          <h4>👥 Contacts</h4>
          <div v-if="hasContacts">
            <div class="scroll-x">
              <table class="table">
                <thead>
                  <tr>
                    <th>Role</th><th>Name</th><th>Email</th><th>Phone</th><th>Website</th><th>Social</th><th>LinkedIn</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(c, i) in reportObj.contacts" :key="'c'+i">
                    <td>{{ c.role || '—' }}</td>
                    <td>{{ c.name || '—' }}</td>
                    <td><a v-if="c.email" :href="'mailto:'+c.email">{{ c.email }}</a><span v-else>—</span></td>
                    <td><a v-if="c.phone" :href="'tel:'+c.phone">{{ c.phone }}</a><span v-else>—</span></td>
                    <td><a v-if="c.website" :href="c.website" target="_blank">{{ c.website }}</a><span v-else>—</span></td>
                    <td>
                      <div class="stack">
                        <a v-for="(s, si) in (c.socials || [])" :key="'s'+si" :href="s" target="_blank">{{ s }}</a>
                        <span v-if="!c.socials || !c.socials.length">—</span>
                      </div>
                    </td>
                    <td><a v-if="c.linkedin" :href="c.linkedin" target="_blank">LinkedIn</a><span v-else>—</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-else class="muted">No contacts found in this report.</div>
        </section>

        <!-- TOURS -->
        <section v-if="outputMode === 'tours'">
          <h4>🎟️ Tours</h4>
          <div class="tour-columns">
            <div>
              <h4>Past Tours</h4>
              <ul class="list">
                <li v-for="(t, i) in (reportObj.pastTours || [])" :key="'pt'+i">
                  <strong>{{ t.city || 'City' }}</strong>
                  <span v-if="t.venue"> — {{ t.venue }}</span>
                  <span v-if="t.date"> • {{ t.date }}</span>
                  <span v-if="t.capacity"> • cap {{ t.capacity }}</span>
                </li>
              </ul>
              <div v-if="!reportObj.pastTours || !reportObj.pastTours.length" class="muted">No past tour items.</div>
            </div>

            <div>
              <h4>Predicted / Future Tours</h4>
              <ul class="list">
                <li v-for="(t, i) in (reportObj.futureTours || [])" :key="'ft'+i">
                  <strong>{{ t.city || 'City' }}</strong>
                  <span v-if="t.venue"> — {{ t.venue }}</span>
                  <span v-if="t.window"> • {{ t.window }}</span>
                  <span v-if="t.confidence != null"> • conf {{ t.confidence }}</span>
                  <span v-if="t.capacity"> • cap {{ t.capacity }}</span>
                </li>
              </ul>
              <div v-if="!reportObj.futureTours || !reportObj.futureTours.length" class="muted">No predicted tour items.</div>
            </div>
          </div>
        </section>

        <!-- JSON -->
        <section v-if="outputMode === 'json'" class="json-section">
          <div class="json-toolbar">
            <div class="muted">Showing {{ reportObj ? 'parsed report JSON' : 'raw API payload' }}</div>
            <div class="spacer"></div>
            <button class="btn small ghost" @click="downloadJson">⬇️ Download JSON</button>
            <button class="btn small ghost" @click="copyJson">📋 Copy</button>
          </div>
          <pre class="json-output">{{ reportObj ? pretty(reportObj) : pretty(rawApi) }}</pre>
        </section>

        <!-- VISUALS -->
        <section v-if="hasForecast" class="block">
          <h4>📊 Insights</h4>
          <div class="charts">
            <div class="chart-card">
              <h4>Venue Capacity</h4>
              <div class="chart-wrap"><canvas id="venueChart"></canvas></div>
            </div>
            <div class="chart-card">
              <h4>Seasonality by Month</h4>
              <div class="chart-wrap"><canvas id="monthChart"></canvas></div>
            </div>
            <div class="chart-card">
              <h4>Regions Share</h4>
              <div class="chart-wrap"><canvas id="regionChart"></canvas></div>
            </div>
          </div>
<section v-if="tourStats" class="block">
  <details class="collapsible">
    <summary class="collapsible-summary">
      🧪 Tour Insights (from {{ pastTours.length }} past shows)
    </summary>

    <pre class="json-output">{{ pretty(tourStats) }}</pre>
  </details>
</section>
          <h4>🌎 Forecast Map</h4>
          <div id="map" class="map"></div>
        </section>
<!-- Forecast controls -->
<!-- <div class="flex items-center justify-end gap-2 mb-3">
  <button
    type="button"
    class="px-3 py-1.5 rounded-full text-xs font-medium border border-sky-500/60
           bg-sky-900/40 hover:bg-sky-700/60 transition-colors"
    @click="toggleStadiumPreset"
  >
    <span v-if="!usePresetForecast">Use preset stadium forecast</span>
    <span v-else>Back to AI forecast</span>
  </button>

  <span
    v-if="usePresetForecast"
    class="text-[11px] uppercase tracking-wide text-emerald-300/80"
  >
    Stadium route active
  </span>
</div> -->
<!-- ➕ In your <template>, near the forecast charts/map block -->
<div class="flex items-center justify-end gap-2 mb-3">
  <button
    type="button"
    class="px-3 py-1.5 rounded-full text-xs font-medium border border-sky-500/60
           bg-sky-900/40 hover:bg-sky-700/60 transition-colors"
    @click="toggleStadiumPreset"
  >
    <span v-if="!usePresetForecast">Use preset stadium forecast</span>
    <span v-else>Back to AI forecast</span>
  </button>

  <span
    v-if="usePresetForecast"
    class="text-[11px] uppercase tracking-wide text-emerald-300/80"
  >
    Stadium route active
  </span>
</div>

        <div class="export-controls">
  <button class="btn ghost" @click="exportToPDF">📄 Export PDF (text + JSON)</button>
  <button class="btn ghost" @click="sendEmail">✉️ Email Report (text + JSON)</button>
  <button class="btn ghost" @click="generateShareLink">🔗 Copy Shareable Link</button>
  <button class="btn" :disabled="!textReport && !reportObj" @click="saveCurrent">💾 Save Report</button>
</div>

      </div>
    </transition>
    <section v-if="hasAnyReport" class="card glass result">
  <div class="row">
    <h3>📦 AI Report</h3>
    <div class="spacer"></div>
    <button
      class="btn small ghost"
      @click="showReport = !showReport"
      :aria-expanded="showReport.toString()"
    >
      {{ showReport ? 'Hide' : 'Show' }}
    </button>
  </div>

  <transition name="fade">
    <div v-show="showReport">
      <!-- TEXT -->
      <section v-if="outputMode === 'text'" class="text-report">
        <pre class="mono">{{ textReport || 'No text was returned by the model.' }}</pre>
      </section>

      <div
        v-if="!reportObj && textReport && textReport.startsWith('{')"
        class="error"
      >
        ⚠️ The report looks like raw JSON but failed to parse into a structured object.
      </div>
    </div>
  </transition>
</section>



<div class="card glass gallery">
  <h3>🗂 Saved Reports</h3>

<div v-if="savedQueries.length" class="saved-grid">
  <div v-for="q in savedQueries" :key="q" class="saved-item">
    <button class="btn pill" @click="loadSavedReport(q)" :title="q">
      <span class="ellipsis">{{ shortName(q) }}</span>
    </button>
    <button class="icon-btn danger" @click="deleteSaved(q)" :aria-label="'Delete ' + q" title="Delete">🗑</button>
  </div>

  <div class="saved-item span-all">
    <button class="btn ghost" @click="clearSaved" title="Clear all">🧹 Clear</button>
  </div>
</div>


  <div v-else class="muted">No saved reports yet.</div>
</div>

  </div>
</v-content>
        </vue-page-transition>
</template>

<script>
// Chart.js 2.9.4
import Chart from 'chart.js';
import axios from 'axios';
// Leaflet + marker assets
// Leaflet + marker assets
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Custom stadium marker from your images folder
// Adjust path/name if your file is different
import stadiumMarker from '@/assets/NewMarker.png';


const AI_ANALYST_ICON = require('@/assets/AIANALYST450px.png');

// Use Vite/CLI-friendly custom marker icon
const stadiumIcon = L.icon({
  iconUrl: stadiumMarker,
  iconRetinaUrl: stadiumMarker,
  iconSize: [32, 32],       // tweak to match your asset
  iconAnchor: [16, 32],     // bottom-center
  popupAnchor: [0, -28],    // popup above the icon
  className: 'stadium-marker-icon'
});


// Use Vite-friendly URLs for icons (works in Vue CLI too)
if (L.Icon && L.Icon.Default) {
  delete L.Icon.Default.prototype._getIconUrl;
}

// PDF export
import jsPDF from 'jspdf';
import { ArchiveAPI, NeuralAPI } from '../utils/storage';



/** Offline city→lat/lng dictionary (expand as needed). */
const CITY_DB = {
  "los angeles": { lat: 34.0522, lng: -118.2437, country: "USA", region: "North America" },
  "new york": { lat: 40.7128, lng: -74.0060, country: "USA", region: "North America" },
  "chicago": { lat: 41.8781, lng: -87.6298, country: "USA", region: "North America" },
  "miami": { lat: 25.7617, lng: -80.1918, country: "USA", region: "North America" },
  "atlanta": { lat: 33.7490, lng: -84.3880, country: "USA", region: "North America" },
  "nashville": { lat: 36.1627, lng: -86.7816, country: "USA", region: "North America" },
  "austin": { lat: 30.2672, lng: -97.7431, country: "USA", region: "North America" },
  "dallas": { lat: 32.7767, lng: -96.7970, country: "USA", region: "North America" },
  "houston": { lat: 29.7604, lng: -95.3698, country: "USA", region: "North America" },
  "seattle": { lat: 47.6062, lng: -122.3321, country: "USA", region: "North America" },
  "san francisco": { lat: 37.7749, lng: -122.4194, country: "USA", region: "North America" },
  "las vegas": { lat: 36.1699, lng: -115.1398, country: "USA", region: "North America" },
  "phoenix": { lat: 33.4484, lng: -112.0740, country: "USA", region: "North America" },
  "denver": { lat: 39.7392, lng: -104.9903, country: "USA", region: "North America" },
  "boston": { lat: 42.3601, lng: -71.0589, country: "USA", region: "North America" },
  "washington": { lat: 38.9072, lng: -77.0369, country: "USA", region: "North America" },
  "toronto": { lat: 43.6532, lng: -79.3832, country: "Canada", region: "North America" },
  "vancouver": { lat: 49.2827, lng: -123.1207, country: "Canada", region: "North America" },
  "montreal": { lat: 45.5019, lng: -73.5674, country: "Canada", region: "North America" },
  "mexico city": { lat: 19.4326, lng: -99.1332, country: "Mexico", region: "North America" },
  "london": { lat: 51.5074, lng: -0.1278, country: "UK", region: "Europe" },
  "manchester": { lat: 53.4808, lng: -2.2426, country: "UK", region: "Europe" },
  "dublin": { lat: 53.3498, lng: -6.2603, country: "Ireland", region: "Europe" },
  "paris": { lat: 48.8566, lng: 2.3522, country: "France", region: "Europe" },
  "berlin": { lat: 52.5200, lng: 13.4050, country: "Germany", region: "Europe" },
  "amsterdam": { lat: 52.3676, lng: 4.9041, country: "Netherlands", region: "Europe" },
  "madrid": { lat: 40.4168, lng: -3.7038, country: "Spain", region: "Europe" },
  "barcelona": { lat: 41.3851, lng: 2.1734, country: "Spain", region: "Europe" },
  "lisbon": { lat: 38.7223, lng: -9.1393, country: "Portugal", region: "Europe" },
  "rome": { lat: 41.9028, lng: 12.4964, country: "Italy", region: "Europe" },
  "milan": { lat: 45.4642, lng: 9.1900, country: "Italy", region: "Europe" },
  "stockholm": { lat: 59.3293, lng: 18.0686, country: "Sweden", region: "Europe" },
  "oslo": { lat: 59.9139, lng: 10.7522, country: "Norway", region: "Europe" },
  "copenhagen": { lat: 55.6761, lng: 12.5683, country: "Denmark", region: "Europe" },
  "vienna": { lat: 48.2082, lng: 16.3738, country: "Austria", region: "Europe" },
  "prague": { lat: 50.0755, lng: 14.4378, country: "Czechia", region: "Europe" },
  "warsaw": { lat: 52.2297, lng: 21.0122, country: "Poland", region: "Europe" },
  "budapest": { lat: 47.4979, lng: 19.0402, country: "Hungary", region: "Europe" },
  "istanbul": { lat: 41.0082, lng: 28.9784, country: "Türkiye", region: "Middle East" },
  "dubai": { lat: 25.2048, lng: 55.2708, country: "UAE", region: "Middle East" },
  "tel aviv": { lat: 32.0853, lng: 34.7818, country: "Israel", region: "Middle East" },
  "tokyo": { lat: 35.6762, lng: 139.6503, country: "Japan", region: "Asia" },
  "osaka": { lat: 34.6937, lng: 135.5023, country: "Japan", region: "Asia" },
  "seoul": { lat: 37.5665, lng: 126.9780, country: "South Korea", region: "Asia" },
  "singapore": { lat: 1.3521, lng: 103.8198, country: "Singapore", region: "Asia" },
  "hong kong": { lat: 22.3193, lng: 114.1694, country: "Asia", region: "Asia" },
  "taipei": { lat: 25.0330, lng: 121.5654, country: "Taiwan", region: "Asia" },
  "sydney": { lat: -33.8688, lng: 151.2093, country: "Australia", region: "Oceania" },
  "melbourne": { lat: -37.8136, lng: 144.9631, country: "Australia", region: "Oceania" },
  "auckland": { lat: -36.8485, lng: 174.7633, country: "New Zealand", region: "Oceania" },
  "sao paulo": { lat: -23.5505, lng: -46.6333, country: "Brazil", region: "Latin America" },
  "rio de janeiro": { lat: -22.9068, lng: -43.1729, country: "Brazil", region: "Latin America" },
  "buenos aires": { lat: -34.6037, lng: -58.3816, country: "Argentina", region: "Latin America" },
  "santiago": { lat: -33.4489, lng: -70.6693, country: "Chile", region: "Latin America" },
  "lima": { lat: -12.0464, lng: -77.0428, country: "Peru", region: "Latin America" },
  "bogota": { lat: 4.7110, lng: -74.0721, country: "Colombia", region: "Latin America" },
  "cape town": { lat: -33.9249, lng: 18.4241, country: "South Africa", region: "Africa" },
  "johannesburg": { lat: -26.2041, lng: 28.0473, country: "South Africa", region: "Africa" }
};
const MAX_SPOTIFY_QUERY_CHARS = 2000;
const stripDiacritics = (s='') => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const normalizeKey = (s='') =>
  stripDiacritics(String(s).toLowerCase().trim())
    .replace(/[^\p{L}\p{N}\s,.-]/gu, '')
    .replace(/\s+/g,' ')
    .replace(/\./g,'')
    .trim();

function lookupCity(city, country) {
  if (!city) return null;
  const keyCity = normalizeKey(city);
  const keyBoth = country ? normalizeKey(`${city}, ${country}`) : null;
  return CITY_DB[keyBoth] || CITY_DB[keyCity] || null;
}

const PROMPT_ID = 'pmpt_68eca374c74c8193b5cb30b110e599360250536559a7eba8';
const MODEL = process.env.VUE_APP_OPENAI_MODEL || 'gpt-5.1'; // ✅ required for /v1/responses
const ARTIST_REPORT_JSON_SCHEMA = {
  name: "ArtistReport",
  schema: {
    type: "object",
    additionalProperties: false,
    properties: {
      schemaVersion: { type: "string" },
      primaryName:   { type: "string" },
      summary:       { type: "string" },
      profile: {
        type: "object",
        additionalProperties: false,
        properties: {
          aka:        { type: "array", items: { type: "string" } },
          genres:     { type: "array", items: { type: "string" } },
          hometown:   { type: ["string","null"] },
          yearsActive:{ type: ["string","null"] },
          labels:     { type: "array", items: { type: "string" } },
          description:{ type: "string" }
        }
      },
      audience: {
        type: "object",
        additionalProperties: true,
        properties: {
          demographics: { type: "object", additionalProperties: true },
          topMarkets:   { type: "array", items: { type: "string" } },
          platforms:    { type: "object", additionalProperties: true }
        }
      },
      socials: { type: "array", items: { type: "object", additionalProperties: true } },
      press:   { type: "array", items: { type: "object", additionalProperties: true } },
      awards:  { type: "array", items: { type: "object", additionalProperties: true } },
      brandPartnerships: { type: "array", items: { type: "object", additionalProperties: true } },
      ticketing: { type: "object", additionalProperties: true },
      recommendations: { type: "array", items: { type: "string" } },
      contacts: { type: "array", items: { type: "object", additionalProperties: true } },
      pastTours:{ type: "array", items: { type: "object", additionalProperties: true } },
      futureTours:{ type: "array", items: { type: "object", additionalProperties: true } },
      forecast: { type: "array", items: { type: "object", additionalProperties: true } },
      competitorsPeers: { type: "array", items: { type: "string" } },
      salesPlay: { type: "object", additionalProperties: true },
      sources:   { type: "array", items: { type: "object", additionalProperties: true } },
      generatedAt: { type: "string" }
    },
    required: ["primaryName","summary"]
  }
};
// Put near ARTIST_REPORT_JSON_SCHEMA
const STRICT_SCHEMA_INSTRUCTIONS = (artist) => `
Return BOTH sections, in this order:

1) TEXT REPORT (no chain-of-thought):
   A concise sales-ready brief summarizing:
   - Artist overview and positioning
   - Management team overview (manager(s), agent(s), label/marketing leads—names + orgs; emails/phones only if confidently verified)
   - Contact strategy (who to contact first and why)
   - Touring patterns (seasons, regions, venue tiers) with evidence
   - Past tours highlights (top cities/venues, capacity bands)
   - Forecast & rationale (top 12–20 candidate cities/windows; why those)
   - Opportunities & risks (2–5 bullets each)
   - Recommended next steps (3–7 bullets; practical outreach)
   - Data quality notes & methodology (1–3 lines)

2) ONE JSON OBJECT strictly matching keys (unknown => null or omit):
{
  "schemaVersion": "1.0",
  "primaryName": "${artist}",
  "summary": string,
  "profile": {
    "aka": string[],
    "genres": string[],
    "hometown": string|null,
    "yearsActive": string|null,
    "labels": string[],
    "description": string
  },
  "audience": {
    "demographics": object,
    "topMarkets": string[],
    "platforms": object
  },
  "managementTeam": [
    { "role": string, "name": string|null, "company": string|null, "email": string|null, "phone": string|null, "website": string|null, "linkedin": string|null, "socials": string[] }
  ],
  "contacts": [
    { "role": string, "name": string|null, "email": string|null, "phone": string|null, "website": string|null, "linkedin": string|null, "socials": string[] }
  ],
  "touringAnalysis": {
    "seasonality": { "byMonth": { "Jan": number, ... "Dec": number } },
    "regions": object,
    "countries": object,
    "capacity": { "min": number|null, "max": number|null, "avg": number|null, "median": number|null },
    "averageGapDays": number|null,
    "notes": string|null
  },
  "pastTours": [
    { "city": string|null, "venue": string|null, "country": string|null, "region": string|null, "date": string|null, "capacity": number|null, "lat": number|null, "lng": number|null }
  ],
  "futureTours": [
    { "city": string|null, "venue": string|null, "country": string|null, "region": string|null, "window": string|null, "confidence": number|null, "capacity": number|null, "lat": number|null, "lng": number|null }
  ],
  "forecast": [
    { "city": string|null, "venue": string|null, "country": string|null, "region": string|null, "window": string|null, "confidence": number|null, "capacity": number|null, "lat": number|null, "lng": number|null }
  ],
  "opportunities": string[],
  "risks": string[],
  "salesPlay": {
    "targets": string[],
    "hooks": string[],
    "nextSteps": string[],
    "timeline": string|null
  },
  "sources": [{ "title": string|null, "url": string|null }],
  "dataQuality": { "confidence": string|null, "gaps": string[] },
  "methodology": string|null,
  "generatedAt": string
}

Rules:
- Prefer official sources; include 3–8 sources.
- Never invent emails/phones; if unknown, set null.
- Forecast: 12–20 cities with realistic seasonal windows; confidence 0.55–0.95.
- Numbers must be numbers; ISO dates when specific.
- Output EXACTLY one JSON object (no arrays or multiple objects).
`;

export default {
  name: 'ArtistResearchDashboard',
  data() {
    return {
      artistName: '',
      artistData: null,
      aiAnalystIcon: AI_ANALYST_ICON,
artistQuery: '',
spotifyToken: '',
spotifyTokenExpiry: 0, // epoch ms 
      lastQuery: '',
      loading: false,
      outputMode: 'text', // 'text' | 'contacts' | 'tours' | 'json'
      textReport: '',
      reportObj: null,
      rawApi: null,
      error: '',
      pendingAction: null,
      confirmVisible: false,
      sendingAgent: false,
      agentError: '',
      chartVenue: null,
      chartMonth: null,
      chartRegion: null,
      chartPastYear: null,
chartCapHist: null,
chartPastRegion: null,
showReport: false,
currentConv: null,          // if you haven’t added this yet
    usePresetForecast: false,   // 🔹 active toggle state
    aiForecastBackup: null,      // 🔹 backup of AI forecast
      map: null,
      markers: null,
      pastTourSources: [],   // raw strings/rows scraped from sources
pastTours: [],         // normalized [{city, venue, date, capacity, lat, lng, ...}]
tourStats: null,       // computed stats/seasonality/regions/gaps
predicting: false,     // UI lock while calling model
savedQueries: [],
userQuery: '',
agentTalkTrack: '',      // 🆕 final agent brief text
    agentTalkTrackRaw: null, // 🆕 raw API payload (optional, for debugging)
    isReadingTalk: false,
    agentVoice: null, 
    };
  },
  computed: {
    hasAnyReport() { return !!(this.textReport || this.reportObj); },
    jsonAvailable() { return !!(this.reportObj || this.rawApi); },
    hasForecast() { return !!(this.reportObj && Array.isArray(this.reportObj.forecast) && this.reportObj.forecast.length); },
    hasContacts() { return !!(this.reportObj && Array.isArray(this.reportObj.contacts) && this.reportObj.contacts.length); },
    hasAnyTours() {
      return !!(this.reportObj && ((this.reportObj.pastTours && this.reportObj.pastTours.length) || (this.reportObj.futureTours && this.reportObj.futureTours.length)));
    },
    titleText() {
      const p = this.reportObj?.primaryName?.trim();
      if (!p) return this.artistName || 'Your Research';
      return (p.toLowerCase() === (this.artistName || '').toLowerCase()) ? this.artistName : p;
    },
     avatarState() {
    if (this.error) return 'error';
    if (this.loading && !this.pastTours.length) return 'searching';
    if (this.loading && this.pastTours.length) return 'analyzing';
    if (this.hasAnyReport) return 'done';
    return 'idle';
  },
  pastByYear() {
    const by = {};
    (this.reportObj?.pastTours || []).forEach(t => {
      const d = (t.date || '').slice(0,4);
      if (/^\d{4}$/.test(d)) by[d] = (by[d] || 0) + 1;
    });
    // turn into arrays
    const ys = Object.keys(by).sort();
    return { labels: ys, counts: ys.map(y => by[y]) };
  },
  recoList() {
    const a = Array.isArray(this.reportObj?.recommendations) ? this.reportObj.recommendations : [];
    // De-dupe and trim
    return [...new Set(a.map(x => String(x).trim()).filter(Boolean))].slice(0, 12);
  },
  nextStepsList() {
    const raw = this.reportObj?.salesPlay?.nextSteps;
    const a = Array.isArray(raw) ? raw : [];
    // If nextSteps missing but we have contacts/forecast, generate light defaults
    if (!a.length) {
      const hasMgmt = (this.reportObj?.contacts || []).some(c =>
        /manager|agent|agency|management/i.test(c.role || '')
      );
      const fm = (this.reportObj?.forecast || []).slice(0, 6).map(f => f.city).filter(Boolean);
      const fallback = [
        hasMgmt ? 'Warm outreach to management with one-pager + route ideas' : null,
        fm.length ? `Validate demand in: ${fm.join(', ')}` : null,
        'Draft 8–12 week routing with capacity tiers',
        'Prepare brand/vip upsell ideas for top markets',
        'Set calendar holds & confirm availabilities'
      ].filter(Boolean);
      return fallback;
    }
    // De-dupe and trim
    return [...new Set(a.map(x => String(x).trim()).filter(Boolean))].slice(0, 12);
  },
    finalAgentBrief() {
    if (!this.reportObj) return null;

    const forecast = (this.reportObj.forecast || []).slice(0, 18);
    const topCities = forecast.map(f => ({
      city: f.city || 'City',
      venue: f.venue || null,
      window: f.window || null,
      capacity: f.capacity || null,
      confidence: f.confidence || null,
      region: f.region || f.country || null
    }));

    const stats = this.tourStats || {};
    const regions = stats.regions || {};
    const primaryRegions = Object.entries(regions)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 5)
      .map(([region, count]) => ({ region, count }));

    return {
      artist: this.titleText,
      summary: this.reportObj.summary || '',
      profile: {
        genres: this.reportObj.profile?.genres || [],
        hometown: this.reportObj.profile?.hometown || null,
        labels: this.reportObj.profile?.labels || []
      },
      metrics: {
        totalPastShows: (this.reportObj.pastTours || []).length,
        forecastCount: forecast.length,
        avgCapacity: stats.capacity?.avg || null,
        medianCapacity: stats.capacity?.median || null,
        avgGapDays: stats.gapsDays?.avg || null,
        primaryRegions
      },
      topCities,
      recommendations: this.recoList,
      nextSteps: this.nextStepsList,
      // You can extend this as needed on the agent side
      raw: {
        report: this.reportObj,
        tourStats: this.tourStats,
        forecast: this.reportObj.forecast || []
      }
    };
  },

    // savedQueries() {
    //   return Object.keys(localStorage)
    //     .filter(k => k.startsWith('artist_report_'))
    //     .map(k => k.replace('artist_report_', ''))
    //     .sort((a, b) => a.localeCompare(b));
    // }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const encodedReport = urlParams.get('report');
    if (encodedReport) {
      try {
        const decoded = JSON.parse(atob(decodeURIComponent(encodedReport)));
        this.reportObj = this.normalizeReport(decoded || {}, this.artistName);
        this.ensureForecastFromTours();
        this.textReport = this.buildReadableFromObject(this.reportObj);
        this.outputMode = 'text';
        this.$nextTick(() => {
          if (this.reportObj.forecast.length) this.renderCharts(this.reportObj);
          if (this.reportObj.forecast.some(f => f.lat !== null && f.lng !== null)) this.renderMap(this.reportObj);
        });
      } catch (e) {
        console.error('Failed to parse shared JSON:', e);
      }
    }
    this.refreshSaved();
    this.initAgentVoice();
  },
  watch: {
  reportObj(newVal) {
    if (!newVal) return;
    this.collectPastTours([], { silent: true });
    if (this.pastTours.length) this.analyzeTours(5);
  }
},
  methods: {
    isThinReport(obj) {
  if (!obj || typeof obj !== 'object') return true;
  const few = (a) => !Array.isArray(a) || a.length < 2;
  return (
    few(obj.contacts) &&
    few(obj.pastTours) &&
    few(obj.futureTours) &&
    few(obj.forecast) &&
    few(obj.sources)
  );
},
refreshSaved() {
      try {
        const keys = Object.keys(localStorage)
          .filter(k => k.startsWith('artist_report_'))
          .map(k => k.replace('artist_report_', ''))
          .sort((a, b) => a.localeCompare(b));
        this.savedQueries = keys; // ⬅️ reactive update = gallery refreshes
      } catch (e) {
        console.warn('refreshSaved failed:', e);
      }
    },
        saveCurrent() {
      // guard: nothing to save?
      if (!this.textReport && !this.reportObj) {
        this.error = 'Nothing to save yet.'; 
        return;
      }

      // Build a friendly name for the save key
      const baseName = (this.titleText || this.artistName || 'Research')
        .trim()
        .replace(/\s+/g, ' ')
        .slice(0, 80);

      // Option A: overwrite per artist
      // const key = `artist_report_${baseName}`;

      // Option B: keep history (timestamped)
      const stamp = new Date().toISOString().slice(0,16).replace('T',' ');
      const key = `artist_report_${baseName} — ${stamp}`;

      const payload = {
        textReport: this.textReport || '',
        reportObj: this.reportObj || null,
        rawApi: this.rawApi || null,
        pastTours: this.pastTours || [],
        tourStats: this.tourStats || null,
        savedAt: new Date().toISOString()
      };

      try {
        localStorage.setItem(key, JSON.stringify(payload));
        this.refreshSaved(); // ⬅️ update gallery
      } catch (e) {
        console.warn('localStorage save failed:', e);
        this.error = 'Failed to save report (localStorage full?).';
      }
    },
shortName(q) {
    // q is already without 'artist_report_' in your savedQueries array.
    const max = 22;
    const name = q.replace(/\s*—\s*\d{4}-\d{2}-\d{2}.*/, ''); // drop timestamp suffix if present
    return name.length > max ? name.slice(0, max) + '…' : name;
  },
sanitizeAfterModel(obj) {
  // Drop placeholder/empty sources
  if (Array.isArray(obj?.sources)) {
    obj.sources = obj.sources.filter(s => (s && (s.url || s.title)));
  }
  // Drop obviously empty socials rows
  if (Array.isArray(obj?.socials)) {
    obj.socials = obj.socials.filter(s => (s && (s.url || s.platform)));
  }
  return obj;
},

    pretty(x) { try { return JSON.stringify(x, null, 2); } catch(e) { return String(x); } },
    monthIndex(name) {
      const idx = ['jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec']
        .findIndex(m => name.toLowerCase().startsWith(m));
      return idx >= 0 ? idx : null;
    },
    extractMonthFromWindow(windowStr='') {
      const m = windowStr.match(/\b(Jan(?:uary)?|Feb(?:ruary)?|Mar(?:ch)?|Apr(?:il)?|May|Jun(?:e)?|Jul(?:y)?|Aug(?:ust)?|Sep(?:t\.?|tember)?|Oct(?:ober)?|Nov(?:ember)?|Dec(?:ember)?)\b/i);
      return m ? this.monthIndex(m[1]) : null;
    },
    tryParseJson(s) {
      if (!s || typeof s !== 'string') return null;
      const fence = s.match(/```(?:json)?\s*([\s\S]*?)```/i);
      if (fence && fence[1]) { try { return JSON.parse(fence[1]); } catch (e) { void e; } }
      const m = s.match(/\{[\s\S]*\}/);
      if (m) { try { return JSON.parse(m[0]); } catch (e) { void e; } }
      try { return JSON.parse(s); } catch (e) { void e; }
      return null;
    },
    coerceNum(n, def = null) {
  if (n === null || n === undefined || n === '') return def;
  const v = Number(n);
  return Number.isFinite(v) ? v : def;
},
initAgentVoice() {
  if (typeof window === 'undefined' || !window.speechSynthesis) return;

  const pickVoice = () => {
    const voices = window.speechSynthesis.getVoices() || [];
    if (!voices.length) return;

    // Prefer en-GB (UK English)
    let uk = voices.filter(v =>
      v.lang && v.lang.toLowerCase().startsWith('en-gb')
    );

    // Try to find something that looks like a female UK voice
    let chosen =
      uk.find(v => /female|woman|girl/i.test(v.name)) ||
      uk[0];

    // Fallback: any English voice
    if (!chosen) {
      const en = voices.filter(v =>
        v.lang && v.lang.toLowerCase().startsWith('en-')
      );
      chosen = en[0] || null;
    }

    this.agentVoice = chosen || null;
  };

  pickVoice();

  // Some browsers load voices async
  if (!this.agentVoice) {
    window.speechSynthesis.onvoiceschanged = () => {
      if (!this.agentVoice) pickVoice();
    };
  }
},
  deleteSaved(q) {
    try {
      // q is the suffix without "artist_report_" (because refreshSaved stripped it)
      const key = `artist_report_${q}`;
      localStorage.removeItem(key);

      // If you currently have this report loaded, clear it (optional but nice)
      const loadedKey = this.artistName ? `artist_report_${this.artistName}` : null;
      if (loadedKey === key) {
        this.textReport = '';
        this.reportObj = null;
        this.rawApi = null;
        this.pastTours = [];
        this.tourStats = null;
      }

      this.refreshSaved(); // ✅ update gallery immediately
    } catch (e) {
      console.warn('deleteSaved failed:', e);
      this.error = 'Failed to delete saved report.';
    }
  },

  clearSaved() {
    try {
      const keys = Object.keys(localStorage).filter(k => k.startsWith('artist_report_'));
      keys.forEach(k => localStorage.removeItem(k));

      // Optional: clear current view too
      this.textReport = '';
      this.reportObj = null;
      this.rawApi = null;
      this.pastTours = [];
      this.tourStats = null;

      this.refreshSaved(); // ✅ THIS is what was missing
    } catch (e) {
      console.warn('clearSaved failed:', e);
      this.error = 'Failed to clear saved reports.';
    }
  },
toggleStadiumPreset() {
    // Turning ON preset forecast
    if (!this.usePresetForecast) {
      // Backup current AI forecast (if any)
      if (this.reportObj && Array.isArray(this.reportObj.forecast) && this.reportObj.forecast.length) {
        this.aiForecastBackup = this.reportObj.forecast.map(f => ({ ...f }));
      } else {
        this.aiForecastBackup = null;
      }

      // Use your preset stadium route
      if (typeof this.addManualForecastTop18 === 'function') {
        this.addManualForecastTop18();
      }

      this.usePresetForecast = true;
      return;
    }

    // Turning OFF preset → restore AI forecast if we have it
    if (this.reportObj && this.aiForecastBackup && this.aiForecastBackup.length) {
      this.reportObj.forecast = this.normalizeForecast(this.aiForecastBackup);
      this.textReport = this.buildReadableFromObject(this.reportObj);

      this.$nextTick(() => {
        this.renderCharts(this.reportObj);
        this.renderMap(this.reportObj);
      });
    }

    this.usePresetForecast = false;
  },
addManualForecastTop18() {
  if (!this.reportObj) {
    this.reportObj = {
      primaryName: this.titleText || this.artistName || this.userQuery || '',
      forecast: []
    };
  }

  const preset = [
    { city: 'Los Angeles',   venue: 'SoFi Stadium',              country: 'USA', region: 'North America', window: 'Aug–Sep 2026', capacity: 70000, confidence: 0.93 },
    { city: 'San Francisco', venue: 'Levi’s Stadium',            country: 'USA', region: 'North America', window: 'Aug–Sep 2026', capacity: 68000, confidence: 0.9  },
    { city: 'Seattle',       venue: 'Lumen Field',               country: 'USA', region: 'North America', window: 'Sep 2026',      capacity: 68000, confidence: 0.89 },
    { city: 'Las Vegas',     venue: 'Allegiant Stadium',         country: 'USA', region: 'North America', window: 'Sep–Oct 2026',  capacity: 65000, confidence: 0.92 },
    { city: 'Phoenix',       venue: 'State Farm Stadium',        country: 'USA', region: 'North America', window: 'Oct 2026',      capacity: 63000, confidence: 0.88 },
    { city: 'Dallas',        venue: 'AT&T Stadium',              country: 'USA', region: 'North America', window: 'Oct 2026',      capacity: 80000, confidence: 0.95 },
    { city: 'Houston',       venue: 'NRG Stadium',               country: 'USA', region: 'North America', window: 'Oct–Nov 2026',  capacity: 72000, confidence: 0.9  },
    { city: 'Austin',        venue: 'Darrell K Royal–Texas Mem.',country:'USA', region: 'North America', window: 'Nov 2026',      capacity: 60000, confidence: 0.86 },
    { city: 'Atlanta',       venue: 'Mercedes-Benz Stadium',     country: 'USA', region: 'North America', window: 'Nov 2026',      capacity: 71000, confidence: 0.91 },
    { city: 'Miami',         venue: 'Hard Rock Stadium',         country: 'USA', region: 'North America', window: 'Nov–Dec 2026',  capacity: 65000, confidence: 0.89 },
    { city: 'Chicago',       venue: 'Soldier Field',             country: 'USA', region: 'North America', window: 'Jun 2027',      capacity: 61000, confidence: 0.9  },
    { city: 'New York',      venue: 'MetLife Stadium',           country: 'USA', region: 'North America', window: 'Jun–Jul 2027',  capacity: 80000, confidence: 0.95 },
    { city: 'Boston',        venue: 'Gillette Stadium',          country: 'USA', region: 'North America', window: 'Jul 2027',      capacity: 65000, confidence: 0.9  },
    { city: 'Toronto',       venue: 'Rogers Centre',             country: 'Canada', region: 'North America', window: 'Jul 2027',  capacity: 50000, confidence: 0.88 },
    { city: 'Vancouver',     venue: 'BC Place',                  country: 'Canada', region: 'North America', window: 'Jul–Aug 2027',capacity: 54000,confidence:0.86 },
    { city: 'London',        venue: 'Wembley Stadium',           country: 'UK',  region: 'Europe',         window: 'Aug 2027',      capacity: 85000, confidence: 0.94 },
    { city: 'Paris',         venue: 'Stade de France',           country: 'France', region: 'Europe',      window: 'Aug–Sep 2027',  capacity: 75000, confidence: 0.92 },
    { city: 'Madrid',        venue: 'Estadio Santiago Bernabéu', country: 'Spain', region: 'Europe',      window: 'Sep 2027',      capacity: 70000, confidence: 0.9  }
  ];

  // Normalize so charts/map logic stays consistent
  this.reportObj.forecast = this.normalizeForecast(preset);
  this.textReport = this.buildReadableFromObject(this.reportObj);

  this.$nextTick(() => {
    this.renderCharts(this.reportObj);
    this.renderMap(this.reportObj);
  });
},
    buildAgentTalkTrack() {
      const brief = this.finalAgentBrief;
      if (!brief) return '';

      const lines = [];

      lines.push(`Final stadium and arena forecast briefing for ${brief.artist}.`);

      if (brief.summary) {
        lines.push('');
        lines.push('Executive summary:');
        lines.push(brief.summary);
      }

      // Core metrics
      const m = brief.metrics || {};
      lines.push('');
      lines.push('Key metrics:');
      if (m.totalPastShows != null) {
        lines.push(`- Total historic shows analyzed: ${m.totalPastShows}.`);
      }
      if (m.forecastCount != null) {
        lines.push(`- Forecasted priority markets: ${m.forecastCount}.`);
      }
      if (m.avgCapacity != null || m.medianCapacity != null) {
        const capBits = [];
        if (m.avgCapacity != null) capBits.push(`average capacity ~${m.avgCapacity.toLocaleString()}`);
        if (m.medianCapacity != null) capBits.push(`median ~${m.medianCapacity.toLocaleString()}`);
        lines.push(`- Venue size band: ${capBits.join(', ')}.`);
      }
      if (m.avgGapDays != null) {
        lines.push(`- Typical gap between shows: about ${m.avgGapDays} days.`);
      }
      if (Array.isArray(m.primaryRegions) && m.primaryRegions.length) {
        const regionStr = m.primaryRegions
          .map(r => `${r.region} (${r.count})`)
          .join(', ');
        lines.push(`- Strongest regions by historic volume: ${regionStr}.`);
      }

      // Top forecast cities
      if (Array.isArray(brief.topCities) && brief.topCities.length) {
        lines.push('');
        lines.push('Top forecast cities and windows:');
        brief.topCities.forEach((c, i) => {
          const bits = [];
          bits.push(`${i + 1}. ${c.city}`);
          if (c.region) bits.push(`(${c.region})`);
          if (c.window) bits.push(`in ${c.window}`);
          if (c.capacity) bits.push(`capacity around ${c.capacity.toLocaleString()}`);
          if (c.confidence != null) bits.push(`confidence ${Math.round(c.confidence * 100)}%`);
          lines.push('- ' + bits.join(' '));
        });
      }

      // Recommendations & next steps
      if (Array.isArray(brief.recommendations) && brief.recommendations.length) {
        lines.push('');
        lines.push('Strategic recommendations:');
        brief.recommendations.forEach((r, i) => {
          lines.push(`${i + 1}. ${r}`);
        });
      }

      if (Array.isArray(brief.nextSteps) && brief.nextSteps.length) {
        lines.push('');
        lines.push('Immediate next steps for the sales team:');
        brief.nextSteps.forEach((s, i) => {
          lines.push(`${i + 1}. ${s}`);
        });
      }

      lines.push('');
      lines.push('End of final briefing.');

      return lines.join('\n');
    },

        requestFinalAgentBrief() {
      if (!this.finalAgentBrief) {
        this.error = 'Run research and predictions before sending a final agent brief.';
        return;
      }

      const talkTrack = this.buildAgentTalkTrack();

      this.pendingAction = {
        intent: 'final_report',
        args: {
          artist: this.finalAgentBrief.artist,
          brief: this.finalAgentBrief,   // structured JSON the agent can use
          talkTrack,                     // plain text the agent can read aloud
          sourceComponent: 'ArtistResearchDashboard'
        }
      };

      // Reuse your existing confirmation dialog
      this.confirmVisible = true;
    },

    // ---- normalization helpers (unchanged) ----
    normalizeContactItem(raw = {}) {
      const socials = Array.isArray(raw.socials) ? raw.socials.filter(Boolean) : [];
      return {
        role: (raw.role || raw.title || '').trim() || null,
        name: (raw.name || '').trim() || null,
        email: (raw.email || '').trim() || null,
        phone: (raw.phone || '').trim() || null,
        website: (raw.website || raw.url || '').trim() || null,
        linkedin: (raw.linkedin || raw.linkedIn || '').trim() || null,
        socials
      };
    },
    normalizeContacts(arr) {
      if (!Array.isArray(arr)) return [];
      return arr.map(this.normalizeContactItem).filter(c =>
        c.name || c.email || c.phone || c.website || c.linkedin || (c.socials && c.socials.length)
      );
    },
    normalizeTourItem(raw = {}) {
      const item = {
        city: (raw.city || raw.location || '').trim() || null,
        venue: (raw.venue || '').trim() || null,
        country: (raw.country || '').trim() || null,
        region: (raw.region || '').trim() || null,
        date: (raw.date || raw.performed_on || '').trim() || null,
        window: (raw.window || raw.when || '').trim() || null,
        capacity: this.coerceNum(raw.capacity ?? raw.cap ?? raw.seats, null),
        confidence: this.coerceNum(raw.confidence ?? raw.score ?? raw.prob, null),
        lat: this.coerceNum(raw.lat ?? raw.latitude, null),
        lng: this.coerceNum(raw.lng ?? raw.longitude, null)
      };
      if ((!item.lat || !item.lng) && item.city) {
        const hit = lookupCity(item.city, item.country);
        if (hit) {
          item.lat = item.lat ?? hit.lat;
          item.lng = item.lng ?? hit.lng;
          item.country = item.country || hit.country || null;
          item.region = item.region || hit.region || null;
        }
      }
      return item;
    },
    /* ------------- COLLECT (from your report + AiReporter/web) ------------- */

/**
 * Pulls past-tour candidates from:
 * - this.reportObj.pastTours (if present)
 * - this.textReport (regex lines like "City — Venue | 2023-07-10 | cap 17000")
 * - this.rawApi (if the API response had structured fields)
 * - (Optional) AiReporter live results: if you store them in this.research.results, pass here
 */
// BEFORE (problematic)
// collectPastTours(extraRows = []) {

// AFTER (fixed)
copyRecos() {
    const text = [
      'Recommendations:',
      ...this.recoList.map((r,i)=>`${i+1}. ${r}`),
      '',
      'Next Steps:',
      ...this.nextStepsList.map((s,i)=>`${i+1}. ${s}`)
    ].join('\n');
    navigator.clipboard.writeText(text).catch(()=>{});
  },
collectPastTours(extraRows = [], opts = {}) {
  console.log('[collectPastTours] clicked', { extraRows, opts });
  const { silent = false } = opts;   // ← define silent here
  const rows = [];

  // 1) Structured from report JSON
  if (this.reportObj && Array.isArray(this.reportObj.pastTours) && this.reportObj.pastTours.length) {
    this.reportObj.pastTours.forEach(t => rows.push({
      city: t.city, venue: t.venue, country: t.country, region: t.region,
      date: t.date, capacity: t.capacity, lat: t.lat, lng: t.lng
    }));
  }

  // 2) From raw API top-level
  if (this.rawApi && Array.isArray(this.rawApi.pastTours)) {
    this.rawApi.pastTours.forEach(t => rows.push(t));
  }

  // 3) From textReport (regex)
  if (this.textReport) {
    const lines = this.textReport.split(/\n+/);
    const rx = /^\s*\d*\.\s*([^—|]+?)(?:\s*—\s*([^|]+))?(?:\s*\|\s*(\d{4}-\d{2}-\d{2}))?(?:\s*\|\s*cap\s*([\d,]+))?/i;
    lines.forEach(line => {
      const m = line.match(rx);
      if (m) {
        rows.push({
          city: (m[1] || '').trim() || null,
          venue: (m[2] || '').trim() || null,
          date: (m[3] || '').trim() || null,
          capacity: this.coerceNum(String(m[4] || '').replace(/,/g, ''), null)
        });
      }
    });
  }

  // 4) External rows
  if (Array.isArray(extraRows) && extraRows.length) rows.push(...extraRows);

  // Normalize
  this.pastTours = (typeof this.normalizeTours === 'function') ? this.normalizeTours(rows) : rows;

  if (!this.pastTours.length) {
    if (!silent) {
      this.error = 'No past tour items were detected. Try “include past tour dates with venue and capacity.”';
    }
  } else {
    this.pastTourSources = rows;
  }

  // (persistence try/catch block unchanged)
  try {
    const asText = this.pastTours.map((t,i)=>
      `${i+1}. ${t.city || 'City'}${t.venue?' — '+t.venue:''}${t.date?' | '+t.date:''}${t.capacity?' | cap '+t.capacity:''}`
    ).join('\n');

    if (!this.currentConv && ArchiveAPI && typeof ArchiveAPI.create === 'function') {
      const created = ArchiveAPI.create({
        mode: 'research',
        userText: `Collected past tours for ${this.titleText || this.userQuery || ''}`,
        aiText: asText,
        keywords: ['tours','past','collection']
      });
      this.currentConv = (created && created.id) ? created.id : created;
    } else if (this.currentConv && ArchiveAPI && typeof ArchiveAPI.appendMessage === 'function') {
      ArchiveAPI.appendMessage(this.currentConv, { role: 'system', content: asText }, ['tours','past']);
    }

    if (NeuralAPI && typeof NeuralAPI.ingest === 'function') {
      NeuralAPI.ingest({
        type: 'past_tours',
        artist: this.titleText || this.userQuery || '',
        records: this.pastTours
      });
    }
  } catch (e) {
    console.warn('[persist pastTours] failed:', e);
  }
},



/* ------------- NORMALIZE (maps loose rows → canonical shape) ------------- */

normalizeTours(arr = []) {
  return arr
    .map(raw => this.normalizeTourItem(raw))
    .filter(t => t.city || t.venue || t.date);
},

/* ------------- ANALYZE (seasonality, regions, gaps, capacities) ------------- */

// Analyze only the most recent N years (default 3)
analyzeTours(years = 5) {
  console.log('[analyzeTours] clicked, years =', years);
  if (!this.pastTours.length) return;

  // --- filter to last `years` years (dated rows only) ---
  const now = new Date();
  const cutoff = new Date(now.getFullYear() - years, now.getMonth(), now.getDate());

  const isISO = (s) => /^\d{4}-\d{2}-\d{2}$/.test(s);
  const toDate = (s) => new Date(s);

  // Only keep rows with a parseable ISO date on/after cutoff
  const recent = this.pastTours.filter(t => t.date && isISO(t.date) && toDate(t.date) >= cutoff);

  // If filtering removed everything, fall back to all dated rows to avoid empty stats
  const source = recent.length ? recent : this.pastTours.filter(t => t.date && isISO(t.date));

  // --- histograms & aggregates built from `source` ---
  const byMonth = Array(12).fill(0);
  const regionCount = {};
  const countryCount = {};
  const capacities = [];

  // Sort by date for gaps
  const dated = source.slice().sort((a, b) => a.date.localeCompare(b.date));

  // Fill histograms
  source.forEach(t => {
    const d = isISO(t.date) ? toDate(t.date) : null;
    if (d && !Number.isNaN(d.getTime())) {
      byMonth[d.getMonth()] += 1;
    } else if (t.window) {
      const mi = this.extractMonthFromWindow(String(t.window));
      if (mi !== null) byMonth[mi] += 1;
    }

    const region = t.region || 'Unknown';
    const country = t.country || 'Unknown';
    regionCount[region] = (regionCount[region] || 0) + 1;
    countryCount[country] = (countryCount[country] || 0) + 1;

    if (t.capacity != null) capacities.push(Number(t.capacity));
  });

  // Gaps between dated shows (in days)
  const gaps = [];
  for (let i = 1; i < dated.length; i += 1) {
    const a = new Date(dated[i - 1].date).getTime();
    const b = new Date(dated[i].date).getTime();
    const days = Math.round((b - a) / (1000 * 60 * 60 * 24));
    if (Number.isFinite(days) && days >= 0) gaps.push(days);
  }

  const sum = (xs) => xs.reduce((a, b) => a + b, 0);
  const avg = (xs) => (xs.length ? sum(xs) / xs.length : 0);
  const median = (xs) => {
    if (!xs.length) return 0;
    const s = [...xs].sort((a, b) => a - b);
    const mid = Math.floor(s.length / 2);
    return s.length % 2 ? s[mid] : (s[mid - 1] + s[mid]) / 2;
  };

  this.tourStats = {
    windowYears: years,
    since: cutoff.toISOString().slice(0, 10),
    totalInput: this.pastTours.length,
    count: source.length,
    seasonalityByMonth: {
      labels: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
      counts: byMonth
    },
    regions: regionCount,
    countries: countryCount,
    capacity: {
      count: capacities.length,
      min: capacities.length ? Math.min(...capacities) : null,
      max: capacities.length ? Math.max(...capacities) : null,
      avg: capacities.length ? Math.round(avg(capacities)) : null,
      median: capacities.length ? Math.round(median(capacities)) : null
    },
    gapsDays: {
      count: gaps.length,
      avg: gaps.length ? Math.round(avg(gaps)) : null,
      median: gaps.length ? Math.round(median(gaps)) : null
    },
    analyzedAt: new Date().toISOString()                     
  };
  this.renderPastYearChart();
  this.renderExtraPastCharts();
},

normalizeForecastItem(raw = {}, defaults = {}) {
  const city       = raw.city || raw.town || raw.location || defaults.city || '';
  const venue      = raw.venue || raw.site || '';
  const country    = raw.country || '';
  const region     = raw.region || '';
  const windowStr  = raw.window || raw.date_window || raw.when || raw.month || '';
  const dateStr    = raw.date || raw.show_date || raw.showDate || raw.performed_on || ''; // 🆕
  const capacity   = this.coerceNum(raw.capacity ?? raw.cap ?? raw.seats, null);
  const confidence = this.coerceNum(raw.confidence ?? raw.score ?? raw.prob, null);

  let lat = this.coerceNum(raw.lat ?? raw.latitude, null);
  let lng = this.coerceNum(raw.lng ?? raw.longitude, null);

  if ((raw.coordinates && Array.isArray(raw.coordinates)) && raw.coordinates.length >= 2) {
    lat = lat ?? this.coerceNum(raw.coordinates[0], null);
    lng = lng ?? this.coerceNum(raw.coordinates[1], null);
  }
  if (raw.geo && typeof raw.geo === 'object') {
    lat = lat ?? this.coerceNum(raw.geo.lat ?? raw.geo.latitude, null);
    lng = lng ?? this.coerceNum(raw.geo.lng ?? raw.geo.longitude, null);
  }

  const item = {
    city: String(city).trim() || null,
    venue: venue ? String(venue).trim() : null,
    country: country ? String(country).trim() : null,
    region: region ? String(region).trim() : null,
    window: windowStr ? String(windowStr).trim() : null,
    date: dateStr ? String(dateStr).trim() : null,               // 🆕 keep date
    capacity,
    confidence,
    lat,
    lng
  };

  if ((!item.lat || !item.lng) && item.city) {
    const hit = lookupCity(item.city, item.country);
    if (hit) {
      item.lat = item.lat ?? hit.lat;
      item.lng = item.lng ?? hit.lng;
      item.country = item.country || hit.country || null;
      item.region = item.region || hit.region || null;
    }
  }
  return item;
},

    normalizeForecast(arr, defaults = {}) {
      if (!Array.isArray(arr)) return [];
      const cleaned = arr
        .map(item => this.normalizeForecastItem(item, defaults))
        .filter(f => (f.city && f.city.length) || (f.lat !== null && f.lng !== null));
      cleaned.sort((a, b) => (b.confidence ?? -1) - (a.confidence ?? -1));
      return cleaned;
    },
    normalizeReport(obj, artistName) {
      const base = {
        schemaVersion: obj?.schemaVersion || '1.0',
        primaryName: obj?.primaryName || artistName || '',
        summary: obj?.summary || '',
        profile: {
          aka: Array.isArray(obj?.profile?.aka) ? obj.profile.aka : [],
          genres: Array.isArray(obj?.profile?.genres) ? obj.profile.genres : [],
          hometown: obj?.profile?.hometown || null,
          yearsActive: obj?.profile?.yearsActive || null,
          labels: Array.isArray(obj?.profile?.labels) ? obj.profile.labels : [],
          description: obj?.profile?.description || ''
        },
        audience: {
          demographics: obj?.audience?.demographics || {},
          topMarkets: Array.isArray(obj?.audience?.topMarkets) ? obj.audience.topMarkets : [],
          platforms: obj?.audience?.platforms || {}
        },
        socials: Array.isArray(obj?.socials) ? obj.socials : [],
        press: Array.isArray(obj?.press) ? obj.press : [],
        awards: Array.isArray(obj?.awards) ? obj.awards : [],
        brandPartnerships: Array.isArray(obj?.brandPartnerships) ? obj.brandPartnerships : [],
        ticketing: obj?.ticketing || { avgPriceUSD: null, vipPriceUSD: null, notes: null },
        recommendations: Array.isArray(obj?.recommendations) ? obj.recommendations : [],
        contacts: this.normalizeContacts(obj?.contacts || []),
        pastTours: this.normalizeTours(obj?.pastTours || obj?.past_events || []),
        futureTours: this.normalizeTours(obj?.futureTours || obj?.predictedTours || obj?.upcoming || []),
        forecast: this.normalizeForecast(obj?.forecast ?? obj?.predictions ?? obj?.stops ?? obj?.cities ?? [], { city: '' }),
        competitorsPeers: Array.isArray(obj?.competitorsPeers) ? obj.competitorsPeers : [],
        salesPlay: {
          targets: Array.isArray(obj?.salesPlay?.targets) ? obj.salesPlay.targets : [],
          hooks: Array.isArray(obj?.salesPlay?.hooks) ? obj.salesPlay.hooks : [],
          nextSteps: Array.isArray(obj?.salesPlay?.nextSteps) ? obj.salesPlay.nextSteps : [],
          timeline: obj?.salesPlay?.timeline || null
        },
        sources: Array.isArray(obj?.sources) ? obj.sources : [],
        generatedAt: obj?.generatedAt || new Date().toISOString()
      };

      if (!base.summary) {
        base.summary = `Sales brief for: ${base.primaryName}. Includes profile, audience, contacts, tours, predictions, and a recommended sales play.`;
      }
      if (!base.recommendations.length) {
        base.recommendations = [
          'Warm outreach to management with a concise deck and market proof.',
          'Prioritize top streaming/social markets for near-term routing.',
          'Bundle brand integration and VIP experiences for incremental revenue.'
        ];
      }
      return base;
    },
   extractPrimaryArtist(q = "") {
  const str = String(q).trim();
  if (!str) return "";
  // strip common trailing intent words
  const stopWords = /(past tours?|tour(ing)?|predictions?|contact(s)?|report|dates?|schedule|shows?|concerts?|tickets?)/i;
  const parts = str.split(stopWords);
  const left = parts[0] || str;
  return left
    .replace(/[“”"']/g, "")
    .replace(/[|•\-–—]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
},

async getSpotifyToken() {
  try {
    if (this.spotifyToken && Date.now() < (this.spotifyTokenExpiry || 0) - 60000) {
      return this.spotifyToken;
    }
    const resp = await axios.post(
      "https://accounts.spotify.com/api/token",
      new URLSearchParams({
        grant_type: "client_credentials",
        client_id: "1522ec4d96914840aef42817fe1b387b",
        client_secret: "673c7686457a438488401835249dca6b",
      }),
      { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
    );
    const token = resp.data?.access_token;
    const ttl   = resp.data?.expires_in || 3600; // seconds
    if (!token) throw new Error("Spotify token missing");
    this.spotifyToken = token;
    this.spotifyTokenExpiry = Date.now() + ttl * 1000;
    return token;
  } catch (err) {
    console.error("Error fetching Spotify access token:", err);
    this.spotifyToken = "";
    this.spotifyTokenExpiry = 0;
    throw err;
  }
},
async ensureSpotifyToken() {
  if (!this.spotifyToken || Date.now() >= (this.spotifyTokenExpiry || 0) - 60000) {
    await this.getSpotifyToken();
  }
  return this.spotifyToken;
},
async fetchSpotifyArtist(name) {
  const token = await this.ensureSpotifyToken();
  const raw = String(name || '').trim();
  if (!raw) return null;

  // Split lists like "Drake, Coldplay, Sabrina Carpenter" or "Drake & 21 Savage"
  const candidates = raw
    .split(/\s*(?:,|&|\/|\||\band\b)\s*/i)
    .map(s => s.trim())
    .filter(Boolean);

  // Try each candidate individually for best match
  for (const candidate of candidates) {
    const q = candidate.slice(0, MAX_SPOTIFY_QUERY_CHARS);
    const resp = await axios.get(
      `https://api.spotify.com/v1/search?q=${encodeURIComponent(q)}&type=artist&limit=10`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    const items = resp.data?.artists?.items || [];
    if (!items.length) continue;

    const lc = q.toLowerCase();
    const exact   = items.find(a => a?.name?.toLowerCase() === lc);
    const starts  = items.find(a => a?.name?.toLowerCase().startsWith(lc));
    const contains= items.find(a => a?.name?.toLowerCase().includes(lc));
    const pick = exact || starts || contains || items[0];
    if (pick) return pick;
  }

  // Fallback: try the whole string once (in case user typed a single artist with commas accidentally)
  const qAll = raw.slice(0, MAX_SPOTIFY_QUERY_CHARS);
  const resp = await axios.get(
    `https://api.spotify.com/v1/search?q=${encodeURIComponent(qAll)}&type=artist&limit=10`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  const items = resp.data?.artists?.items || [];
  if (!items.length) return null;

  const lcAll = qAll.toLowerCase();
  const exactAll   = items.find(a => a?.name?.toLowerCase() === lcAll);
  const startsAll  = items.find(a => a?.name?.toLowerCase().startsWith(lcAll));
  const containsAll= items.find(a => a?.name?.toLowerCase().includes(lcAll));
  return exactAll || startsAll || containsAll || items[0];
},





async predictFutureTours() {
  if (!this.pastTours.length) {
    this.error = 'Collect/analyze past tours first.'; return;
  }
  this.predicting = true; this.error = '';

  const PREDICTION_SCHEMA = {
    name: "TourPredictions",
    schema: {
      type: "object",
      additionalProperties: false,
      properties: {
        artist: { type: "string" },
        assumptions: { type: "array", items: { type: "string" } },
        predictions: {
          type: "array",
          items: {
            type: "object",
            additionalProperties: false,
            properties: {
              city: { type: "string" },
              venue: { type: ["string","null"] },
              country: { type: ["string","null"] },
              region: { type: ["string","null"] },
              window: { type: "string" },         // e.g., "Mar–Apr 2026"
              confidence: { type: "number" },     // 0..1
              capacity: { type: ["number","null"] },
              lat: { type: ["number","null"] },
              lng: { type: ["number","null"] }
            },
            required: ["city","window","confidence"]
          }
        }
      },
      required: ["artist","predictions"]
    }
  };

  // Keep payload small-ish but representative
  const sample = this.pastTours.slice(-120); // last 120 shows max
  const stats  = this.tourStats || {};

  const input = `
You are a live entertainment analyst. Given structured past tour data and computed stats,
predict the next 12–20 likely cities (optionally with venues) and date windows for upcoming tours.
Respect demand signals: capacities, seasonality, gaps, regions. Do not hallucinate specific venue emails/phones.

Return only JSON matching the schema.
Artist: ${this.titleText}

PAST_TOURS (JSON lines):
${JSON.stringify(sample, null, 2)}

STATS:
${JSON.stringify(stats, null, 2)}

Rules:
- Use realistic seasonal windows (e.g., "Jun–Jul 2026", "Q4 2025").
- Include lat/lng if confident; otherwise null.
- capacity is your best estimate for the likely venue size in that market.
- confidence 0..1; keep within 0.55–0.95. Prefer 12–20 items.
`;

  try {
    const body = {
      model: MODEL,
      response_format: { type: 'json_schema', json_schema: PREDICTION_SCHEMA },
      max_output_tokens: 3000,
      temperature: 0.2,
      input
    };
    const { res, data } = await (this.doFetch || (async (b) => {
      // use the doFetch already in your component
      const url = 'https://api.openai.com/v1/responses';
      const headers = {
        'Content-Type': 'application/json',
          'Authorization': `Bearer ${process.env.VUE_APP_OPENAI_API_KEY || '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'}`
      };
      const r = await fetch(url, { method: 'POST', headers, body: JSON.stringify(b) });
      const j = await r.json().catch(() => ({}));
      return { res: r, data: j };
    }))(body);

    if (!res.ok) throw new Error(data?.error?.message || `HTTP ${res.status}`);
    const text = data?.output_text || data?.choices?.[0]?.text || '';
    const parsed = this.tryParseJson(text);
    if (!parsed || !Array.isArray(parsed.predictions)) throw new Error('Model did not return valid predictions JSON.');

    // Normalize predictions through your tour normalizer so charts/maps work:
    const normalized = this.normalizeForecast(parsed.predictions);
    // Wire them into your existing UI (e.g., show in “Forecast” tab):
    if (!this.reportObj) this.reportObj = { primaryName: this.titleText || this.userQuery };
    this.reportObj.futureTours = this.normalizeTours(parsed.predictions);
    this.reportObj.forecast = normalized;

    // Render visuals
    this.$nextTick(() => {
      this.renderCharts(this.reportObj);
      this.renderMap(this.reportObj);
    });

    // Persist to Archive + Brain
    try {
      const textSummary = `Predicted ${normalized.length} stops:\n` +
        normalized.map((p,i)=>`${i+1}. ${p.city}${p.venue?' — '+p.venue:''}${p.window?' | '+p.window:''}${p.capacity?' | cap '+p.capacity:''} | conf ${p.confidence}`).join('\n');
      // Build the payload you already have:
const save = {
  mode: 'research',
  userText: this.titleText || this.userQuery || '',
  aiText: textSummary,                 // whatever summary string you built
  keywords: ['tour', 'prediction', 'forecast', 'research']
};

// Persist to Archive
try {
  if (!this.currentConv && ArchiveAPI && typeof ArchiveAPI.create === 'function') {
    const created = ArchiveAPI.create(save);
    this.currentConv = (created && created.id) ? created.id : created;
  } else if (this.currentConv && ArchiveAPI && typeof ArchiveAPI.appendMessage === 'function') {
    ArchiveAPI.appendMessage(
      this.currentConv,
      { role: 'assistant', content: textSummary },
      save.keywords
    );
  }
} catch (e) {
  console.warn('[ArchiveAPI] persist failed:', e);
}

// Persist to Neural
try {
  if (NeuralAPI && typeof NeuralAPI.ingest === 'function') {
    NeuralAPI.ingest({
      type: 'tour_prediction',
      query: this.titleText || this.userQuery || '',
      predictions: normalized // your normalized predictions array
    });
  }
} catch (e) {
  console.warn('[NeuralAPI] ingest failed:', e);
}
    } catch (e) {
      console.warn('Post-prediction persist failed:', e);
    }

  } catch (e) {
    this.error = `Prediction failed: ${e.message || e}`;
  } finally {
    this.predicting = false;
  }

},

    ensureForecastFromTours() {
      if (this.reportObj && (!this.reportObj.forecast || !this.reportObj.forecast.length)) {
        const candidates = (this.reportObj.futureTours && this.reportObj.futureTours.length)
          ? this.reportObj.futureTours
          : (this.reportObj.pastTours || []);
        if (candidates.length) {
          const byCity = {};
          candidates.forEach(t => {
            const key = (t.city || 'Unknown').trim();
            if (!byCity[key]) byCity[key] = { ...t, count: 0 };
            byCity[key].count += 1;
          });
          const approx = Object.values(byCity).map(v => {
            const row = {
              city: v.city || 'Unknown',
              venue: v.venue || null,
              country: v.country || null,
              region: v.region || null,
              window: v.window || v.date || null,
              capacity: v.capacity ?? null,
              confidence: v.confidence ?? null,
              lat: v.lat ?? null,
              lng: v.lng ?? null
            };
            if ((!row.lat || !row.lng) && row.city) {
              const hit = lookupCity(row.city, row.country);
              if (hit) {
                row.lat = row.lat ?? hit.lat;
                row.lng = row.lng ?? hit.lng;
                row.country = row.country || hit.country || null;
                row.region = row.region || hit.region || null;
              }
            }
            return row;
          });
          this.reportObj.forecast = this.normalizeForecast(approx);
        }
      }
    },

    buildReadableFromObject(obj) {
      const out = [];
      out.push(`# ${obj.primaryName || this.artistName || 'Music Research'}`);

      if (obj.summary) out.push(`\n## Overview\n${obj.summary}`);

      if (obj.profile) {
        const p = obj.profile;
        const rows = [];
        if (p.description) rows.push(p.description);
        const chips = [];
        if (p.aka?.length) chips.push(`AKA: ${p.aka.join(', ')}`);
        if (p.genres?.length) chips.push(`Genres: ${p.genres.join(', ')}`);
        if (p.hometown) chips.push(`Hometown: ${p.hometown}`);
        if (p.yearsActive) chips.push(`Years Active: ${p.yearsActive}`);
        if (p.labels?.length) chips.push(`Labels: ${p.labels.join(', ')}`);
        if (rows.length || chips.length) {
          out.push(`\n## Profile`);
          if (rows.length) out.push(rows.join('\n'));
          if (chips.length) out.push(chips.join(' | '));
        }
      }

      if (obj.audience) {
        const a = obj.audience;
        const parts = [];
        if (a.demographics && Object.keys(a.demographics).length) {
          const d = a.demographics;
          const demoBits = [];
          if (d.coreAge) demoBits.push(`Core Age: ${d.coreAge}`);
          if (d.genderSkew) demoBits.push(`Gender: ${d.genderSkew}`);
          if (d.notes) demoBits.push(d.notes);
          if (demoBits.length) parts.push(demoBits.join(' | '));
        }
        if (a.topMarkets?.length) parts.push(`Top Markets: ${a.topMarkets.join(', ')}`);
        if (a.platforms && Object.keys(a.platforms).length) {
          const pl = a.platforms;
          const plBits = Object.entries(pl).filter(([,v]) => v).map(([k,v]) => `${k}: ${v}`);
          if (plBits.length) parts.push(plBits.join(' | '));
        }
        if (parts.length) {
          out.push(`\n## Audience & Platforms`);
          out.push(parts.join('\n'));
        }
      }

      if (Array.isArray(obj.socials) && obj.socials.length) {
        out.push(`\n## Socials / Official`);
        obj.socials.forEach((s, i) =>
          out.push(`${i+1}. ${s.platform || 'Link'}${s.url ? ` — ${s.url}` : ''}`)
        );
      }

      if ((obj.press && obj.press.length) || (obj.awards && obj.awards.length)) {
        out.push(`\n## Press & Awards`);
        if (obj.press?.length) {
          out.push(`- Press:`);
          obj.press.forEach(pr => out.push(`  • ${pr.title || 'Article'}${pr.outlet ? ` — ${pr.outlet}` : ''}${pr.date ? ` (${pr.date})` : ''}${pr.url ? ` — ${pr.url}` : ''}`));
        }
        if (obj.awards?.length) {
          out.push(`- Awards:`);
          obj.awards.forEach(aw => out.push(`  • ${aw.name || 'Award'}${aw.year ? ` ${aw.year}` : ''}${aw.category ? ` — ${aw.category}` : ''}${aw.result ? ` (${aw.result})` : ''}`));
        }
      }

      if ((obj.brandPartnerships && obj.brandPartnerships.length) || obj.ticketing) {
        out.push(`\n## Commercial`);
        if (obj.brandPartnerships?.length) {
          out.push(`- Brand Partnerships:`);
          obj.brandPartnerships.forEach(bp =>
            out.push(`  • ${bp.brand || 'Brand'}${bp.type ? ` — ${bp.type}` : ''}${bp.notes ? ` — ${bp.notes}` : ''}${bp.url ? ` — ${bp.url}` : ''}`)
          );
        }
        if (obj.ticketing && (obj.ticketing.avgPriceUSD || obj.ticketing.vipPriceUSD || obj.ticketing.notes)) {
          const t = obj.ticketing;
          out.push(`- Ticketing: ${[
            t.avgPriceUSD ? `Avg $${t.avgPriceUSD}` : null,
            t.vipPriceUSD ? `VIP $${t.vipPriceUSD}` : null,
            t.notes || null
          ].filter(Boolean).join(' | ')}`);
        }
      }

      if (Array.isArray(obj.contacts) && obj.contacts.length) {
        out.push(`\n## Contacts`);
        obj.contacts.forEach((c, i) => {
          const line = [
            `${i + 1}. ${c.role || 'Contact'}`,
            c.name ? ` — ${c.name}` : '',
            c.email ? ` | ${c.email}` : '',
            c.phone ? ` | ${c.phone}` : '',
            c.website ? ` | ${c.website}` : '',
            c.linkedin ? ` | ${c.linkedin}` : '',
            c.socials && c.socials.length ? ` | socials: ${c.socials.join(', ')}` : ''
          ].join('');
          out.push(line);
        });
      }

      if (Array.isArray(obj.pastTours) && obj.pastTours.length) {
        out.push(`\n## Past Tours (${obj.pastTours.length})`);
        obj.pastTours.forEach((t, i) =>
          out.push(`${i + 1}. ${t.city || 'City'}${t.venue ? ` — ${t.venue}` : ''}${t.date ? ` | ${t.date}` : ''}${t.capacity ? ` | cap ${t.capacity}` : ''}`)
        );
      }
      if (Array.isArray(obj.futureTours) && obj.futureTours.length) {
        out.push(`\n## Predicted / Future Tours (${obj.futureTours.length})`);
        obj.futureTours.forEach((t, i) =>
          out.push(`${i + 1}. ${t.city || 'City'}${t.venue ? ` — ${t.venue}` : ''}${t.window ? ` | ${t.window}` : ''}${t.confidence != null ? ` | conf ${t.confidence}` : ''}${t.capacity ? ` | cap ${t.capacity}` : ''}`)
        );
      }

      if (Array.isArray(obj.recommendations) && obj.recommendations.length) {
        out.push(`\n## Recommendations`);
        obj.recommendations.forEach((r, i) => out.push(`${i + 1}. ${r}`));
      }

      if (Array.isArray(obj.competitorsPeers) && obj.competitorsPeers.length) {
        out.push(`\n## Competitors / Peers`);
        out.push(obj.competitorsPeers.join(', '));
      }

      if (obj.salesPlay && (obj.salesPlay.targets?.length || obj.salesPlay.hooks?.length || obj.salesPlay.nextSteps?.length || obj.salesPlay.timeline)) {
        out.push(`\n## Sales Play`);
        if (obj.salesPlay.targets?.length) out.push(`- Targets: ${obj.salesPlay.targets.join(', ')}`);
        if (obj.salesPlay.hooks?.length) out.push(`- Hooks: ${obj.salesPlay.hooks.join(', ')}`);
        if (obj.salesPlay.nextSteps?.length) {
          out.push(`- Next Steps:`);
          obj.salesPlay.nextSteps.forEach((s, i) => out.push(`  ${i+1}. ${s}`));
        }
        if (obj.salesPlay.timeline) out.push(`- Timeline: ${obj.salesPlay.timeline}`);
      }

      if (Array.isArray(obj.forecast) && obj.forecast.length) {
        out.push(`\n## Forecast (Top ${obj.forecast.length})`);
        obj.forecast.forEach((f, i) =>
          out.push(`${i + 1}. ${f.city || 'City'}${f.venue ? ` — ${f.venue}` : ''}${f.capacity ? ` (cap ${f.capacity})` : ''}${f.window ? ` | ${f.window}` : ''}${f.confidence != null ? ` | conf ${f.confidence}` : ''}`)
        );
      }

      if (Array.isArray(obj.sources) && obj.sources.length) {
        out.push(`\n## Sources`);
        obj.sources.forEach((s, i) => out.push(`${i+1}. ${s.title || s.url || 'Source'}${s.url ? ' — ' + s.url : ''}`));
      }

      return out.join('\n');
    },

    extractTextFromApiPayload(api) {
      const direct = api?.choices?.[0]?.text || api?.output_text || api?.text;
      if (direct) return direct;
      if (Array.isArray(api)) {
        const msgs = api
          .filter(r => r.type === 'message' && Array.isArray(r.content))
          .flatMap(r => r.content)
          .filter(c => c.type === 'output_text' && typeof c.text === 'string')
          .map(c => c.text.trim());
        if (msgs.length) return msgs.join("\n\n");
      }
      return '';
    },

async runResearch() {
  this.loading = true;
  this.error = '';
  this.rawApi = null;
  this.textReport = '';
  this.reportObj = null;
  this.outputMode = 'text';

  const query = (this.artistName || '').trim();
  this.userQuery = query;        // 🆕 keep query for Archive / Neural / logs

  const unifiedInput = STRICT_SCHEMA_INSTRUCTIONS(query);
  this.lastQuery = query;

  if (!query) {
    this.loading = false;
    this.error = 'Please enter an artist or research query.';
    return;
  }

  // 🆕 1) Try to fetch Spotify artist up-front so the image shows immediately
  try {
    const sp = await this.fetchSpotifyArtist(query);
    if (sp) {
      this.artistData = sp; // <-- your template can render images[0].url right away
      // (Optional) pre-seed a tiny visible header while AI runs
      if (!this.textReport && !this.reportObj) {
        this.textReport = `# ${sp.name}\n\nLoading research…`;
      }
    }
  } catch (e) {
    console.warn('[Spotify] lookup skipped:', e?.message || e);
  }

  // ---------- Build payloads (with required model) ----------
  const payloadMinimal = {
    model: MODEL,
    max_output_tokens: 3500,
    input: unifiedInput, // ✅ add
    prompt: {
      id: PROMPT_ID,
      version: '5',
      variables: {
        years_back: 'default',
        artist_name: query,
        regions: 'default',
        goals: 'default',
        deliverables: 'default',
        automation: 'default',
        share_format: 'default',
        top_n: 'default',
        artist_list: 'default',
        capacity_range: 'default',
        num_stops: 'default',
        user_query: query,
        require_full_report: 'true',
        // If your prompt supports it:
        extra_instructions: unifiedInput // ✅ harmless if ignored
      }
    }
  };

  const payloadWithDefaults = {
    model: MODEL,
    max_output_tokens: 3000,
    input: unifiedInput, // ✅ add
    prompt: {
      id: PROMPT_ID,
      version: '5',
      variables: {
        years_back: '5',
        artist_name: query,
        regions: 'Global',
        goals: 'artist profile; audience; socials; press/awards; brand partnerships; ticketing; contact discovery; tour history; market prediction; competitors; sales play',
        deliverables: 'summary; profile; audience; socials; press; awards; brandPartnerships; ticketing; contacts; pastTours; futureTours; forecast; competitorsPeers; salesPlay; sources; JSON data; readable text',
        automation: 'none',
        share_format: 'json_and_text',
        top_n: '12',
        artist_list: '',
        capacity_range: '3000-8000',
        num_stops: '15',
        user_query: query,
        require_full_report: 'true',
        extra_instructions: unifiedInput // ✅
      }
    }
  };

  const doFetch = async (body) => {
    const url = 'https://api.openai.com/v1/responses';
    const headers = {
      'Content-Type': 'application/json',
      // ⚠️ In production, proxy this server-side; don't expose keys in client code.
      'Authorization': `Bearer ${process.env.VUE_APP_OPENAI_API_KEY || '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'}`
    };
    let res, data;
    try {
      res = await fetch(url, { method: 'POST', headers, body: JSON.stringify(body) });
      data = await res.json().catch(() => ({}));
      if (res.status >= 500) throw new Error(`Server error ${res.status}`);
      return { res, data };
    } catch (e) {
      await new Promise(r => setTimeout(r, 900));
      res = await fetch(url, { method: 'POST', headers, body: JSON.stringify(body) });
      data = await res.json().catch(() => ({}));
      return { res, data };
    }
  };

  const hasFn = (name) => typeof this[name] === 'function';

  const normalizeAfterParse = (obj) => {
    if (hasFn('normalizeReport')) {
      obj = this.normalizeReport(obj || {}, query);
    } else {
      obj = obj || {};
      obj.schemaVersion = obj.schemaVersion || '1.0';
      obj.primaryName   = obj.primaryName || query;
      obj.summary       = obj.summary || `Research summary generated for: ${query}.`;
      obj.recommendations = Array.isArray(obj.recommendations) ? obj.recommendations : [
        'Prioritize outreach to key roles relevant to routing and promotion.',
        'Leverage strongest forecast markets for near-term routing.',
        'Align venue capacities to demand bands and seasonal peaks.'
      ];
      obj.contacts   = Array.isArray(obj.contacts) ? obj.contacts : [];
      obj.pastTours  = Array.isArray(obj.pastTours) ? obj.pastTours : (Array.isArray(obj.past_events) ? obj.past_events : []);
      obj.futureTours= Array.isArray(obj.futureTours)? obj.futureTours: (Array.isArray(obj.predictedTours) ? obj.predictedTours : []);
      obj.forecast   = Array.isArray(obj.forecast) ? obj.forecast : (Array.isArray(obj.predictions) ? obj.predictions : []);
      obj.sources    = Array.isArray(obj.sources) ? obj.sources : [];
      obj.generatedAt= obj.generatedAt || new Date().toISOString();
    }

    const fillGeo = (row) => {
      if (!row) return row;
      const hasLatLng = (v) => v !== undefined && v !== null && v !== '';
      if ((!hasLatLng(row.lat) || !hasLatLng(row.lng)) && typeof lookupCity === 'function' && row.city) {
        const hit = lookupCity(row.city, row.country);
        if (hit) {
          row.lat = hasLatLng(row.lat) ? row.lat : hit.lat;
          row.lng = hasLatLng(row.lng) ? row.lng : hit.lng;
          row.country = row.country || hit.country || null;
          row.region  = row.region  || hit.region  || null;
        }
      }
      return row;
    };

    if (Array.isArray(obj.pastTours))  obj.pastTours  = obj.pastTours.map(fillGeo);
    if (Array.isArray(obj.futureTours))obj.futureTours= obj.futureTours.map(fillGeo);
    if (Array.isArray(obj.forecast))   obj.forecast   = obj.forecast.map(fillGeo);

    if ((!obj.forecast || !obj.forecast.length) && hasFn('ensureForecastFromTours')) {
      this.reportObj = obj;
      this.ensureForecastFromTours();
      obj = this.reportObj;
    }

    return obj;
  };

  const buildReadable = (obj) => {
    if (hasFn('buildReadableFromObject')) return this.buildReadableFromObject(obj);
    const lines = [`# ${obj.primaryName || query}`];
    if (obj.summary) lines.push(`\n## Overview\n${obj.summary}\n`);
    if (Array.isArray(obj.contacts) && obj.contacts.length) {
      lines.push(`\n## Contacts`);
      obj.contacts.forEach((c, i) => {
        const parts = [
          `${i+1}. ${c.role || 'Contact'}`,
          c.name ? ` — ${c.name}` : '',
          c.email ? ` | ${c.email}` : '',
          c.phone ? ` | ${c.phone}` : '',
          c.website ? ` | ${c.website}` : '',
          c.linkedin ? ` | ${c.linkedin}` : '',
          (c.socials && c.socials.length) ? ` | socials: ${c.socials.join(', ')}` : ''
        ];
        lines.push(parts.join(''));
      });
    }
    if (Array.isArray(obj.pastTours) && obj.pastTours.length) {
      lines.push(`\n## Past Tours (${obj.pastTours.length})`);
      obj.pastTours.forEach((t, i) => lines.push(`${i+1}. ${t.city || 'City'}${t.venue ? ' — '+t.venue : ''}${t.date ? ' | '+t.date : ''}${t.capacity ? ' | cap '+t.capacity : ''}`));
    }
    if (Array.isArray(obj.futureTours) && obj.futureTours.length) {
      lines.push(`\n## Predicted / Future Tours (${obj.futureTours.length})`);
      obj.futureTours.forEach((t, i) => lines.push(`${i+1}. ${t.city || 'City'}${t.venue ? ' — '+t.venue : ''}${t.window ? ' | '+t.window : ''}${t.confidence != null ? ' | conf '+t.confidence : ''}${t.capacity ? ' | cap '+t.capacity : ''}`));
    }
    if (Array.isArray(obj.recommendations) && obj.recommendations.length) {
      lines.push(`\n## Recommendations`);
      obj.recommendations.forEach((r, i) => lines.push(`${i+1}. ${r}`));
    }
    if (Array.isArray(obj.sources) && obj.sources.length) {
      lines.push(`\n## Sources`);
      obj.sources.forEach((s, i) => lines.push(`${i+1}. ${s.title || s.url || 'Source'}${s.url ? ' — '+s.url : ''}`));
    }
    if (Array.isArray(obj.forecast) && obj.forecast.length) {
      lines.push(`\n## Forecast (Top ${obj.forecast.length})`);
      obj.forecast.forEach((f, i) => lines.push(`${i+1}. ${f.city || 'City'}${f.venue ? ' — '+f.venue : ''}${f.capacity ? ' (cap '+f.capacity+')' : ''}${f.window ? ' | '+f.window : ''}${f.confidence != null ? ' | conf '+f.confidence : ''}`));
    }
    return lines.join('\n');
  };

  try {
    // A) Minimal variables using Prompt ID (with model)
    let { res, data } = await doFetch(payloadMinimal);
    this.rawApi = data;

    // B) Retry with explicit defaults if tool complains
    const notFound = !res.ok && /not\s*found/i.test(data?.error?.message || '');
    const needsVars = !res.ok && /missing|required|variables|placeholders/i.test(data?.error?.message || '');
    if (notFound || needsVars) {
      const withDefaults = await doFetch(payloadWithDefaults);
      res = withDefaults.res;
      data = withDefaults.data;
      this.rawApi = data;
    }

    // C) Fallback: direct text/schema (with model)
    if (!res.ok) {
      const fb = await doFetch({ model: MODEL, input: unifiedInput });
      res = fb.res; data = fb.data; this.rawApi = data;
      if (!res.ok) throw new Error(data?.error?.message || `HTTP ${res.status}`);
    }

    // ---------- Parse ----------
    const text =
      data?.choices?.[0]?.text ||
      data?.output_text ||
      (Array.isArray(data?.output) && data.output[0]?.content && Array.isArray(data.output[0].content) && data.output[0].content[0]?.text) ||
      data?.text ||
      '';

    let parsed = this.tryParseJson(typeof text === 'string' ? text : '');
    if (!parsed && data && typeof data === 'object' && data.result && typeof data.result === 'object') {
      parsed = data.result;
    }
    if (!parsed && data && typeof data === 'object' && data.forecast && Array.isArray(data.forecast)) {
      parsed = data;
    }

    let obj = null;

    if (parsed && typeof parsed === 'object') {
      obj = parsed;
    } else {
      obj = { primaryName: query, summary: (typeof text === 'string' ? text.trim() : '') || '' };
    }

    // If first pass is thin, force a JSON-only, schema-enforced second pass
    if (this.isThinReport(obj)) {
      const forceBody = {
        model: MODEL,
        response_format: { type: "json_schema", json_schema: ARTIST_REPORT_JSON_SCHEMA },
        max_output_tokens: 6000,
        input: unifiedInput // ✅ use the SAME unified instructions
      };
      const forced = await doFetch(forceBody);
      if (forced?.res?.ok) {
        // The Responses API with json_schema usually returns JSON in output_text
        const forcedText =
          forced.data?.output_text ||
          forced.data?.choices?.[0]?.message?.content ||
          forced.data?.choices?.[0]?.text || '';
        const forcedParsed = this.tryParseJson(forcedText) || forced.data?.result || forced.data;
        if (forcedParsed && typeof forcedParsed === 'object') {
          obj = forcedParsed;
        }
      }
    }

    // sanitize + normalize + render
    obj = this.sanitizeAfterModel(obj);
    this.reportObj = normalizeAfterParse(obj);

    // 🆕 2) Light enrichment from Spotify if we have it (keeps your structure intact)
    if (this.artistData) {
      // merge genres if empty
      if (this.reportObj?.profile && (!this.reportObj.profile.genres || !this.reportObj.profile.genres.length)) {
        this.reportObj.profile.genres = this.artistData.genres || [];
      }
      // basic platform metrics
      this.reportObj.audience = this.reportObj.audience || {};
      this.reportObj.audience.platforms = Object.assign({}, this.reportObj.audience.platforms, {
        spotifyFollowers: this.artistData.followers?.total || null,
        spotifyPopularity: this.artistData.popularity || null
      });
      // add spotify link to socials/sources
      const spUrl = this.artistData.external_urls?.spotify || null;
      if (spUrl) {
        this.reportObj.socials = Array.isArray(this.reportObj.socials) ? this.reportObj.socials : [];
        if (!this.reportObj.socials.find(s => s.url === spUrl)) {
          this.reportObj.socials.unshift({ platform: 'spotify', url: spUrl, verified: true });
        }
        this.reportObj.sources = Array.isArray(this.reportObj.sources) ? this.reportObj.sources : [];
        if (!this.reportObj.sources.find(s => s.url === spUrl)) {
          this.reportObj.sources.unshift({ title: 'Spotify', url: spUrl });
        }
      }
    }

    this.textReport = buildReadable(this.reportObj);

    this.collectPastTours([], { silent: true });
    if (this.pastTours.length) this.analyzeTours(5);

    // ---------- Persist & visuals ----------
    if (typeof this.saveToLocalStorage === 'function') {
      this.saveToLocalStorage({ textReport: this.textReport, reportObj: this.reportObj });
    }
    this.$nextTick(() => {
      if (typeof this.renderCharts === 'function' && this.reportObj?.forecast?.length) this.renderCharts(this.reportObj);
      if (typeof this.renderMap === 'function' && this.reportObj?.forecast?.some(f => f.lat != null && f.lng != null)) this.renderMap(this.reportObj);
      this.renderPastYearChart();
      this.renderExtraPastCharts();
    });

    if (
      (!this.reportObj.contacts || !this.reportObj.contacts.length) &&
      (!this.reportObj.pastTours || !this.reportObj.pastTours.length) &&
      (!this.reportObj.futureTours || !this.reportObj.futureTours.length) &&
      (!this.reportObj.forecast || !this.reportObj.forecast.length)
    ) {
      this.error = 'ℹ️ The AI did not return detailed contacts/tours this time. The text section may still contain them. Try refining the query (e.g., “include manager/agent emails and official website links”).';
    }

  } catch (err) {
    this.error = err?.message || 'Unexpected error occurred.';
    console.error('[AI REQUEST ERROR]', err);
  } finally {
    this.loading = false;
  }
},

    async sendAgentPayloadToApi(payload) {
      // Build a unified input string for the Responses API, similar style to runResearch()
      const unifiedInput = `
You are an internal touring & sales assistant.
Your job is to take the following JSON payload (final artist brief + instructions)
and generate a concise, spoken-style talk track for a human booking agent.

Goals:
- 1–2 sentence opening: who the artist is and why they matter.
- 3–6 bullets: key tour insights (top markets, capacities, timing windows).
- 2–4 bullets: recommended outreach targets (names/roles if present).
- 2–4 bullets: negotiation angles / risk notes.
- 1–2 sentence closing call-to-action (what the agent should do next).

Tone:
- Confident, clear, and businesslike.
- Written so the agent can read it verbatim on a call.

Return ONLY plain text talk track (no JSON, no markdown).

PAYLOAD:
${JSON.stringify(payload, null, 2)}
`;

      const body = {
        model: MODEL,
        max_output_tokens: 1200,
        input: unifiedInput
      };

      const url = 'https://api.openai.com/v1/responses';
      const headers = {
        'Content-Type': 'application/json',
        // ⚠️ In production, proxy this server-side; don't expose keys in client code.
        'Authorization': `Bearer ${process.env.VUE_APP_OPENAI_API_KEY || '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'}`
      };

      let res, data;
      try {
        res = await fetch(url, { method: 'POST', headers, body: JSON.stringify(body) });
        data = await res.json().catch(() => ({}));
        if (res.status >= 500) throw new Error(`Server error ${res.status}`);
      } catch (e) {
        // retry once, same pattern as runResearch()
        await new Promise(r => setTimeout(r, 900));
        res = await fetch(url, { method: 'POST', headers, body: JSON.stringify(body) });
        data = await res.json().catch(() => ({}));
      }

      if (!res.ok) {
        throw new Error(data?.error?.message || `Agent API HTTP ${res.status}`);
      }

      const text =
        data?.choices?.[0]?.text ||
        data?.output_text ||
        (Array.isArray(data?.output) &&
         data.output[0]?.content &&
         Array.isArray(data.output[0].content) &&
         data.output[0].content[0]?.text) ||
        data?.text ||
        '';

      return {
        talkTrack: typeof text === 'string' ? text.trim() : '',
        raw: data
      };
    },

    async approveAction() {
  if (!this.pendingAction) return;
  this.sendingAgent = true;
  this.agentError = '';

  try {
    const payload = {
      query: this.artistName || this.titleText || '',
      intent: this.pendingAction.intent,
      args: this.pendingAction.args,
      source: 'ArtistResearchDashboard',
      timestamp: Date.now()
    };

    // Call OpenAI Responses API using the same pattern as runResearch()
    const result = await this.sendAgentPayloadToApi(payload);

// 🆕 Store in component so template can show + read it
this.agentTalkTrack = result.talkTrack || '';
this.agentTalkTrackRaw = result.raw || null;

// 🆕 Auto-start reading the new report from the beginning
if (this.agentTalkTrack) {
  this.readAgentTalkTrack(true);
}


    // Emit so parent / voice layer can also handle it if needed
    this.$emit('run-agent', {
      payload,
      talkTrack: this.agentTalkTrack,
      raw: this.agentTalkTrackRaw
    });

    this.confirmVisible = false;
    this.pendingAction = null;
  } catch (e) {
    this.agentError = e?.message || 'Failed to send action to AI agent.';
    console.error('[approveAction] error:', e);
  } finally {
    this.sendingAgent = false;
  }
},

readAgentTalkTrack(startOver = false) {
  if (!this.agentTalkTrack) return;
  if (typeof window === 'undefined' || !window.speechSynthesis) {
    console.warn('speechSynthesis not available');
    return;
  }

  // If user wants to start over (or we auto-start after creation),
  // cancel any existing speech first.
  if (startOver) {
    window.speechSynthesis.cancel();
  }

  const utterance = new SpeechSynthesisUtterance(this.agentTalkTrack);

  // Use the selected UK female voice if we found one
  if (this.agentVoice) {
    utterance.voice = this.agentVoice;
  }

  utterance.onend = () => {
    this.isReadingTalk = false;
  };
  utterance.onerror = () => {
    this.isReadingTalk = false;
  };

  this.isReadingTalk = true;
  window.speechSynthesis.speak(utterance);
},

stopAgentTalkTrack() {
  if (typeof window === 'undefined' || !window.speechSynthesis) return;
  window.speechSynthesis.cancel();
  this.isReadingTalk = false;
},


    
    async fetchMorePastTours() {
    if (!this.titleText) { this.error = 'Enter an artist first.'; return; }
    this.loading = true; this.error = '';

    const prompt = `
Return only JSON with "pastTours": a list of at least 50 historic shows for "${this.titleText}" over the last 10 years.
Each item must include: city, venue (if known), date (ISO YYYY-MM-DD when known), capacity (number or null).
Prefer official/credible sources. Do not include duplicates.
`;

    try {
      const body = {
        model: MODEL,
        response_format: {
          type: 'json_schema',
          json_schema: {
            name: "PastToursOnly",
            schema: {
              type: "object",
              additionalProperties: false,
              properties: {
                pastTours: {
                  type: "array",
                  items: {
                    type: "object",
                    additionalProperties: true,
                    properties: {
                      city: { type: ["string","null"] },
                      venue:{ type: ["string","null"] },
                      country:{ type: ["string","null"] },
                      region:{ type: ["string","null"] },
                      date: { type: ["string","null"] },
                      capacity: { type: ["number","null"] }
                    }
                  }
                }
              },
              required: ["pastTours"]
            }
          }
        },
        max_output_tokens: 4000,
        temperature: 0.2,
        input: prompt
      };

      const { res, data } = await (this.doFetch || (async (b) => {
        const url = 'https://api.openai.com/v1/responses';
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${process.env.VUE_APP_OPENAI_API_KEY || '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'}`
        };
        const r = await fetch(url, { method: 'POST', headers, body: JSON.stringify(b) });
        return { res: r, data: await r.json().catch(()=>({})) };
      }))(body);

      if (!res.ok) throw new Error(data?.error?.message || `HTTP ${res.status}`);

      const text = data?.output_text || data?.choices?.[0]?.text || '';
      const parsed = this.tryParseJson(text);
      const more = Array.isArray(parsed?.pastTours) ? parsed.pastTours : [];

      if (!more.length) throw new Error('No additional tours returned.');

      // merge + de-dup by (city|venue|date)
      const keyOf = (t) => [t.city||'', t.venue||'', t.date||''].map(s=>String(s).toLowerCase().trim()).join('|');
      const existing = new Set((this.reportObj?.pastTours || []).map(keyOf));
      const merged = [...(this.reportObj?.pastTours || [])];

      more.forEach(t => {
        const n = this.normalizeTourItem(t);
        if ((n.city || n.venue || n.date) && !existing.has(keyOf(n))) {
          merged.push(n);
          existing.add(keyOf(n));
        }
      });

      if (!this.reportObj) this.reportObj = { primaryName: this.titleText };
      this.reportObj.pastTours = merged;

      // refresh dependent state
      this.collectPastTours([], { silent: true });
      this.analyzeTours(5);
      this.$nextTick(() => {
        this.renderPastYearChart();
        this.renderExtraPastCharts();
      });
    } catch(e) {
      this.error = e?.message || 'Failed to load more tours.';
    } finally {
      this.loading = false;
    }
  },

  // Render the per-year past tours chart
  renderPastYearChart() {
    const el = document.getElementById('pastYearChart');
    if (!el) return;

    if (this.chartPastYear) { this.chartPastYear.destroy(); this.chartPastYear = null; }

    const { labels, counts } = this.pastByYear;
    if (!labels.length) return;

    this.chartPastYear = new Chart(el.getContext('2d'), {
      type: 'bar',
      data: {
        labels,
        datasets: [{ label: 'Shows / Year', data: counts, backgroundColor: 'rgba(59,130,246,0.6)', borderColor: 'rgba(59,130,246,1)', borderWidth: 1 }]
      },
      options: {
        responsive: true, maintainAspectRatio: false,
        scales: { yAxes: [{ ticks: { beginAtZero: true, precision: 0 } }], xAxes: [{ ticks: { autoSkip: true } }] }
      }
    });
  },

  // Capacity histogram + region pie for *past* tours
  renderExtraPastCharts() {
    // Capacity histogram
    const hEl = document.getElementById('capacityHistChart');
    if (hEl) {
      if (this.chartCapHist) { this.chartCapHist.destroy(); this.chartCapHist = null; }
      const caps = (this.reportObj?.pastTours || []).map(t => Number(t.capacity||0)).filter(n => n>0);
      if (caps.length) {
        // simple 8-bin histogram
        const min = Math.min(...caps), max = Math.max(...caps);
        const bins = 8, step = (max-min)/bins || 1;
        const edges = Array.from({length: bins+1}, (_,i)=>Math.round(min + i*step));
        const counts = Array(bins).fill(0);
        caps.forEach(v => {
          let idx = Math.floor((v-min)/step);
          if (idx>=bins) idx = bins-1;
          counts[idx]+=1;
        });
        const labels = counts.map((_,i)=>`${edges[i]}–${edges[i+1]}`);

        this.chartCapHist = new Chart(hEl.getContext('2d'), {
          type: 'bar',
          data: { labels, datasets: [{ label: 'Venue Capacity (Past)', data: counts, backgroundColor:'rgba(99,102,241,0.5)', borderColor:'rgba(99,102,241,1)', borderWidth:1 }] },
          options: { responsive:true, maintainAspectRatio:false, scales:{ yAxes:[{ticks:{beginAtZero:true, precision:0}}] } }
        });
      }
    }

    // Past regions pie
    const rEl = document.getElementById('pastRegionChart');
    if (rEl) {
      if (this.chartPastRegion) { this.chartPastRegion.destroy(); this.chartPastRegion = null; }
      const counts = {};
      (this.reportObj?.pastTours || []).forEach(t => {
        const k = t.region || t.country || 'Other';
        counts[k] = (counts[k]||0)+1;
      });
      const labels = Object.keys(counts);
      const values = labels.map(k => counts[k]);
      if (labels.length) {
        this.chartPastRegion = new Chart(rEl.getContext('2d'), {
          type: 'doughnut',
          data: { labels, datasets: [{ data: values, backgroundColor: labels.map((_,i)=>`rgba(34,197,94,${0.35 + (i%5)*0.12})`) }] },
          options: { responsive:true, maintainAspectRatio:false }
        });
      }
    }
    },

    rejectAction() {
      this.confirmVisible = false;
      this.pendingAction = null;
      this.agentError = '';
    },

    // ---- CHARTS / MAP / STORAGE / EXPORT (unchanged) ----
    renderCharts(dataObj) {
      if (this.chartVenue) { this.chartVenue.destroy(); this.chartVenue = null; }
      if (this.chartMonth) { this.chartMonth.destroy(); this.chartMonth = null; }
      if (this.chartRegion) { this.chartRegion.destroy(); this.chartRegion = null; }
      if (!(dataObj && Array.isArray(dataObj.forecast) && dataObj.forecast.length)) return;

      const venueEl = document.getElementById('venueChart');
      if (venueEl) {
        const cities = dataObj.forecast.map(f => f.city || 'Unknown');
        const capacities = dataObj.forecast.map(f => Number(f.capacity || 0));
        this.chartVenue = new Chart(venueEl.getContext('2d'), {
          type: 'bar',
          data: {
            labels: cities,
            datasets: [{
              label: 'Venue Capacity',
              data: capacities,
              backgroundColor: 'rgba(59, 130, 246, 0.6)',
              borderColor: 'rgba(59,130,246,1)',
              borderWidth: 1
            }]
          },
          options: {
            responsive: true, maintainAspectRatio: false, animation: { duration: 600 },
            legend: { display: true },
            scales: { yAxes: [{ ticks: { beginAtZero: true } }], xAxes: [{ ticks: { autoSkip: true, maxRotation: 0 } }] },
            tooltips: { mode: 'index', intersect: false }
          }
        });
      }

      const monthEl = document.getElementById('monthChart');
      if (monthEl) {
        const months = Array(12).fill(0);
        dataObj.forecast.forEach(f => {
          const mi = this.extractMonthFromWindow(f.window || '');
          if (mi !== null) months[mi] += 1;
        });
        const labels = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        this.chartMonth = new Chart(monthEl.getContext('2d'), {
          type: 'line',
          data: {
            labels,
            datasets: [{
              label: 'Stops per Month (forecast)',
              data: months,
              fill: false,
              borderColor: 'rgba(34,197,94,1)',
              backgroundColor: 'rgba(34,197,94,0.2)'
            }]
          },
          options: {
            responsive: true, maintainAspectRatio: false, animation: { duration: 600 },
            legend: { display: true },
            scales: { yAxes: [{ ticks: { beginAtZero: true, precision: 0 } }], xAxes: [{ ticks: { autoSkip: false } }] },
            tooltips: { mode: 'index', intersect: false }
          }
        });
      }

      const regionEl = document.getElementById('regionChart');
      if (regionEl) {
        const counts = {};
        dataObj.forecast.forEach(f => {
          const r = f.region || f.country || 'Other';
          counts[r] = (counts[r] || 0) + 1;
        });
        const labels = Object.keys(counts);
        const values = labels.map(k => counts[k]);
        this.chartRegion = new Chart(regionEl.getContext('2d'), {
          type: 'doughnut',
          data: {
            labels,
            datasets: [{
              data: values,
              backgroundColor: labels.map((_, i) => `rgba(99,102,241,${0.35 + (i % 5) * 0.12})`)
            }]
          },
          options: { responsive: true, maintainAspectRatio: false, legend: { display: true } }
        });
      }
    },

renderMap(dataObj) {
  const mapEl = document.getElementById('map');
  const hasPoints = !!(
    dataObj &&
    Array.isArray(dataObj.forecast) &&
    dataObj.forecast.some(f => f.lat && f.lng)
  );
  if (!mapEl) return;

  if (!this.map) {
    this.map = L.map(mapEl).setView([40, 0], 4);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap'
    }).addTo(this.map);
    this.markers = L.layerGroup().addTo(this.map);
    setTimeout(() => this.map.invalidateSize(), 150);
  }

  this.markers.clearLayers();
  if (!hasPoints) return;

  const bounds = [];

  dataObj.forecast.forEach(f => {
    if (!f.lat || !f.lng) return;

    const title = `${f.city || 'City'}${f.venue ? ' — ' + f.venue : ''}`;

    const when = f.date || f.window || null;
    const regionCountry = [f.region, f.country].filter(Boolean).join(' · ');
    const capacity =
      f.capacity != null && f.capacity !== ''
        ? Number(f.capacity).toLocaleString()
        : null;
    const confidence =
      f.confidence != null && f.confidence !== ''
        ? `${(Number(f.confidence) * 100).toFixed(1)}%`
        : null;

    const rows = [];

    if (when) {
      rows.push(`<div><strong>${when}</strong></div>`);
    }
    if (regionCountry) {
      rows.push(`<div>${regionCountry}</div>`);
    }
    if (capacity) {
      rows.push(`<div>Capacity: ${capacity}</div>`);
    }
    if (confidence) {
      rows.push(`<div>Confidence: ${confidence}</div>`);
    }

    // Optional: show raw lat/lng in tiny text
    rows.push(
      `<div style="font-size:10px;opacity:0.7;margin-top:4px;">` +
      `Lat: ${Number(f.lat).toFixed(3)}, Lng: ${Number(f.lng).toFixed(3)}` +
      `</div>`
    );

    const popupHtml = `
      <div class="forecast-popup">
        <div style="font-weight:600;margin-bottom:2px;">${title}</div>
        ${rows.join('')}
      </div>
    `.trim();

const marker = L.marker([Number(f.lat), Number(f.lng)], {
  icon: stadiumIcon
}).bindPopup(popupHtml);


    this.markers.addLayer(marker);
    bounds.push([Number(f.lat), Number(f.lng)]);
  });

  if (bounds.length) {
    this.map.fitBounds(bounds, { padding: [30, 30] });
  }
},



    saveToLocalStorage(payload) {
      try {
        const key = `artist_report_${this.artistName}`;
        localStorage.setItem(key, JSON.stringify(payload));
        this.refreshSaved(); // ⬅️ ensure gallery updates
      } catch (e) {
        console.warn('localStorage save failed:', e);
      }
    },
    loadSavedReport(query) {
      try {
        const raw = localStorage.getItem(`artist_report_${query}`);
        if (!raw) return;
        const saved = JSON.parse(raw);
        this.artistName = query;
        this.textReport = saved.textReport || '';
        this.reportObj = saved.reportObj || null;
        this.ensureForecastFromTours();
        this.$nextTick(() => {
          this.renderCharts(this.reportObj);
          this.renderMap(this.reportObj);
        });
      } catch (e) {
        this.error = 'Failed to load saved report.';
      }
    },
    // clearSaved() {
    //   const keys = Object.keys(localStorage).filter(k => k.startsWith('artist_report_'));
    //   keys.forEach(k => localStorage.removeItem(k));
    // },

    exportToPDF() {
      try {
        const doc = new jsPDF({ unit: 'pt', format: 'a4' });
        doc.setFontSize(14);
        doc.text(`AI Music Research Report`, 40, 40);
        doc.setFontSize(11);
        doc.text(this.titleText, 40, 62);
        doc.setFontSize(10);
        const text = this.textReport || '';
        const json = this.reportObj ? `\n\nJSON Data:\n${this.pretty(this.reportObj)}` : '';
        const lines = doc.splitTextToSize(text + json, 520);
        doc.text(lines, 40, 84);
        doc.save(`${(this.titleText || 'music_research').replace(/\s+/g,'_')}.pdf`);
      } catch (e) {
        this.error = 'PDF export failed.';
      }
    },

    sendEmail() {
      const subject = `Music Research: ${this.titleText}`;
      const body = this.textReport || '';
      const mailto = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      window.location.href = mailto;
    },

    generateShareLink() {
      if (!this.reportObj) return;
      const json = this.pretty(this.reportObj);
      const encoded = encodeURIComponent(btoa(json));
      const link = `${window.location.origin}${window.location.pathname}?report=${encoded}`;
      navigator.clipboard.writeText(link).then(() => {
        alert(`✅ Shareable link copied!\n\n${link}`);
      }).catch(() => alert('❌ Failed to copy link.'));
    },

    copyJson() {
      const src = this.reportObj ? this.pretty(this.reportObj) : this.pretty(this.rawApi || {});
      navigator.clipboard.writeText(src).catch(() => {});
    },

    downloadJson() {
      const blob = new Blob(
        [ this.reportObj ? this.pretty(this.reportObj) : this.pretty(this.rawApi || {}) ],
        { type: 'application/json;charset=utf-8' }
      );
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${(this.titleText || 'report').replace(/\s+/g,'_')}.json`;
      a.click();
      URL.revokeObjectURL(url);
    }
  }
};
</script>

<style scoped>
.text-report {
  background: #fdfdfd;
  color: #222;
  padding: 2rem;
  font-family: 'Georgia', serif;
  line-height: 1.6;
  font-size: 1.05rem;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.05);
  white-space: pre-wrap;
}
.text-report .mono {
  font-family: inherit;
  font-size: inherit;
  background: transparent;
}

.dashboard {
  display: flex; flex-direction: column; gap: 2rem; padding: 2rem;
  background: radial-gradient(circle at top left, #0f172a, #111827);
  color: #e5e7eb; min-height: 100vh; font-family: 'Share Tech Mono', monospace;
  margin-top: 0px; padding-top: -1.5rem;
}
.card { padding: 2.5rem; border-radius: 1rem; background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(12px); box-shadow: 0 0 20px rgba(0,0,0,0.3); }
.glass { border: 1px solid rgba(255,255,255,0.1); }

.input {
  width: 100%; padding: 0.75rem; margin-bottom: 1rem; border-radius: 0.5rem;
  border: none; background: rgba(255,255,255,0.05); color: #fff; font-size: 1rem;
}


.error { margin-top: 1rem; font-weight: bold; color: #f87171; }
.result { animation: fadeInUp 0.7s ease-out; }

.toolbar { display: flex; align-items: center; justify-content: space-between; gap: 1rem; }
.view-switch { display: flex; gap: 0.5rem; flex-wrap: wrap; }

.json-section .json-toolbar { display:flex; align-items:center; gap:.75rem; margin-bottom:.5rem; }
.json-section .json-toolbar .spacer { flex:1; }
.json-output {
  background: #0f172a; color: #d1d5db; padding: 1rem; border-radius: 0.5rem;
  font-size: 0.85rem; white-space: pre-wrap;
}

.block { margin-top: 1.5rem; }

.charts {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  grid-gap: 1rem;
  margin-bottom: 1rem;
}
.chart-card {
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 10px;
  padding: 0.5rem 0.75rem;
}
.chart-wrap { position: relative; height: 220px; }

.map { width: 100%; height: 400px; border-radius: 8px; overflow: hidden; }

.export-controls { margin-top: 1.5rem; display: flex; gap: 1rem; flex-wrap: wrap; }

.gallery { margin-top: 2rem; }
.grid { display: flex; flex-wrap: wrap; gap: 0.5rem; }
.muted { opacity: 0.5; font-style: italic; }

/* Contacts table + Tours columns */
.scroll-x { overflow-x: auto; }
.table {
  width: 100%; border-collapse: collapse; min-width: 720px;
  background: rgba(255,255,255,0.03);
}
.table th, .table td {
  text-align: left; padding: 10px 12px; border-bottom: 1px solid rgba(255,255,255,0.08);
  font-size: 0.95rem;
}
.table th { font-weight: 700; opacity: 0.9; }
.stack { display: flex; gap: .35rem; flex-wrap: wrap; }

.tour-columns {
  display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 1rem;
}
.list { list-style: none; padding: 0; margin: .5rem 0 0; }
.list li { padding: .5rem .6rem; background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 8px; margin-bottom: .5rem; }

@keyframes fadeInUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
.fade-enter-active, .fade-leave-active { transition: opacity 0.5s; }
.fade-enter, .fade-leave-to { opacity: 0; }
.collapsible-summary {
  cursor: pointer;
  user-select: none;
  list-style: none;
  display: flex;
  align-items: center;
  gap: .5rem;
  padding: .25rem 0;
}
.collapsible-summary::-webkit-details-marker { display: none; }
.collapsible-summary::before {
  content: '▸';
  transition: transform .2s ease;
}
details[open] .collapsible-summary::before {
  transform: rotate(90deg);
}
.saved-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: .6rem;
}

.saved-item {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: .4rem;
  align-items: center;
}

.span-all { grid-column: 1 / -1; }

.btn.pill {
  width: 100%;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 9999px;
  padding: .5rem .75rem;
}

.icon-btn {
  border: 1px solid var(--border, #e5e7eb);
  background: transparent;
  border-radius: .6rem;
  padding: .4rem .55rem;
  line-height: 1;
  cursor: pointer;
}

.icon-btn.danger { color: #ef4444; border-color: #ef4444; }
.icon-btn:hover { background: rgba(0,0,0,.04); }
.icon-btn.danger:hover { background: rgba(239,68,68,.08); }

.ellipsis { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

.card.mini { padding: .9rem 1rem; }
.card.wide { grid-column: span 2; }
.card.tall { grid-row: span 2; }
.card.full { grid-column: span 6; grid-row: span 6; }

.kvs .k { color: var(--muted, #6b7280); margin-right: .4rem; }
.kvs .v { font-weight: 600; }
.kvs > div { display: flex; justify-content: space-between; gap: .75rem; padding: .15rem 0; }

.chips { display: flex; flex-wrap: wrap; gap: .4rem; }
.chip { padding: .2rem .5rem; border-radius: 999px; border: 1px solid var(--border,#e5e7eb); font-size: .85rem; }

.row { display: flex; align-items: center; gap: .5rem; }
.spacer { flex: 1 1 auto; }
.list.compact li { padding: .15rem 0; }

.chart-wrap.sm { height: 190px; }

/* Avatar */
.avatar-wrap {
  display: grid;
  grid-template-columns: 68px 1fr;
  align-items: center;
  gap: .6rem;
  margin: .6rem 0 .4rem;
}
.avatar {
  width: 60px; height: 60px; display: grid; place-items: center;
  border-radius: 999px; background: rgba(99,102,241,.08);
  border: 1px solid rgba(99,102,241,.15);
  font-size: 24px;
}
.avatar-note { font-size: 1.3rem; color: var(--muted,#6b7280); }

.avatar-wrap.searching .avatar { animation: spin 1.2s linear infinite; }
.avatar-wrap.analyzing .avatar { animation: pulse 1.2s ease-in-out infinite; }
@keyframes spin { to { transform: rotate(360deg); } }
@keyframes pulse { 0%,100%{ transform: scale(1); } 50%{ transform: scale(1.06);} }

.grid-two {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: .75rem 1rem;
  margin-top: .25rem;
}

.checklist {
  list-style: none;
  padding: 0;
  margin: .25rem 0 0;
}
.checklist li {
  position: relative;
  padding-left: 1.4rem;
  margin: .25rem 0;
}
.checklist li::before {
  content: '✔';
  position: absolute;
  left: 0;
  top: 0;
  line-height: 1.1;
  opacity: .75;
}
.row { display:flex; align-items:center; gap:.5rem; }
.spacer { flex:1; }
/* in your <style scoped> or global */
.artist-header { margin-bottom: .75rem; padding-block: 1.2rem; }
.artist-head { display:flex; align-items:center; gap:1rem; margin-left: 60px; }
.artist-avatar { width:150px; height:150px; border-radius:9999px; object-fit:cover; }
.artist-avatar2 { width:220px; height:220px; border-radius:9999px; object-fit:cover; }
.artist-name { font-size:1.7rem; font-weight:700; margin:0; }
.artist-subname { font-size:1.25rem; color:var(--muted,#6b7280); }
.artist-meta .chips { display:flex; flex-wrap:wrap; gap:3.5rem; margin:.25rem 0; padding-block: 1.25rem;}
.chip { background:rgba(255, 255, 255, 0.392); padding:.25rem .5rem; border-radius:999px; font-size:1.25rem; }
.link { font-size:.85rem; opacity:.85; }
.avatar {
  width: 56px;
  height: 56px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  overflow: hidden;
}

.avatar-icon {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transform: translateZ(0);
}

/* Optional: subtle state vibes */
.avatar-wrap.searching .avatar-icon {
  animation: pulse 1.2s ease-in-out infinite;
}
.avatar-wrap.analyzing .avatar-icon {
  animation: spinSlow 2.8s linear infinite;
}
.avatar-wrap.error .avatar-icon {
  filter: grayscale(1) contrast(1.1);
}
.avatar-wrap.done .avatar-icon {
  filter: saturate(1.2) contrast(1.05);
}

@keyframes pulse {
  0%, 100% { transform: scale(1); opacity: 0.95; }
  50% { transform: scale(1.04); opacity: 1; }
}
@keyframes spinSlow {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

</style>
